export const ptBR = {
  translation: {
    // Projects Module
    projects_module: {
      title: "Projetos",
      subtitle: "Gerencie seus projetos e tarefas",
      new_project: "Novo Projeto",
      edit_project: "Editar Projeto",
      create_project: "Criar Projeto",
      delete_project: "Excluir Projeto",
      confirm_delete: "Tem certeza que deseja excluir este projeto? Todas as tarefas associadas também serão excluídas.",
      no_projects: "Nenhum projeto encontrado",
      create_first_project: "Crie seu primeiro projeto para organizar suas tarefas",
      loading_projects: "Carregando projetos...",
      active_projects: "Projetos Ativos",
      completed: "Concluídos",
      start_date: "Data Início",
      end_date: "Data Fim",
      priority: "Prioridade",
      deadline: "Prazo",
      status: {
        active: "Ativo",
        completed: "Concluído",
        cancelled: "Cancelado",
      },
    },
    // Tickets
    tickets: {
      title: "Tickets",
      subtitle: "Gerencie chamados e solicitações internas",
      new_ticket: "Novo Ticket",
      open_ticket: "Abrir Ticket",
      ticket_title: "Título",
      title_placeholder: "Descreva o problema brevemente",
      description_placeholder: "Detalhes do problema...",
      category: "Categoria",
      priority: "Prioridade",
      open: "Abertos",
      in_progress: "Em andamento",
      resolved: "Resolvidos",
      search_placeholder: "Buscar tickets...",
      filter_by_status: "Filtrar por status",
      all_statuses: "Todos os status",
      no_tickets: "Nenhum ticket encontrado",
      try_filters: "Tente alterar os filtros",
      open_first_ticket: "Abra um ticket para registrar problemas ou solicitações",
      no_description: "Sem descrição",
      comments: "Comentários",
      no_comments: "Nenhum comentário",
      add_comment_placeholder: "Adicionar comentário...",
      support: "Suporte",
      you: "Você",
    },
    // Customer Plans extended
    customer_plans: {
      title: "Planos de Clientes",
      subtitle: "Gerencie assinaturas e planos recorrentes",
      new_plan: "Novo Plano",
      create_plan: "Criar Plano",
      create_plan_btn: "Criar Plano",
      subscribe_client: "Inscrever Cliente",
      subscribe_plan: "Inscrever em Plano",
      subscribe: "Inscrever",
      plan_name: "Nome do Plano",
      plan_name_placeholder: "Ex: Plano Mensal Premium",
      plan_description: "Descrição do plano",
      plan_value: "Valor",
      periodicity: "Periodicidade",
      monthly: "Mensal",
      yearly: "Anual",
      month: "mês",
      year: "ano",
      total: "Total",
      active: "Ativos",
      expiring: "A vencer",
      overdue: "Vencidas",
      cancelled: "Canceladas",
      subscriptions: "Assinaturas",
      plans: "Planos",
      search: "Buscar cliente ou plano...",
      all: "Todos",
      no_subscriptions: "Nenhuma assinatura",
      no_subscriptions_found: "Nenhuma assinatura encontrada",
      subscribe_clients: "Inscreva clientes em planos",
      try_filters: "Tente alterar os filtros",
      customer: "Cliente",
      plan: "Plano",
      start_date: "Data de início",
      select_customer: "Selecione o cliente",
      search_customer: "Buscar cliente...",
      no_customer_found: "Nenhum cliente encontrado.",
      select_plan: "Selecione o plano",
      search_plan: "Buscar plano...",
      no_plan_found: "Nenhum plano encontrado.",
      start: "Início",
      next_due: "Próximo vencimento",
      reminder_sent_email: "Lembrete enviado por e-mail",
      email_sent_to: "E-mail enviado para {{customer}} sobre o plano {{plan}}",
      whatsapp_reminder_message: "Olá {{customer}}! Seu plano \"{{plan}}\" vence em {{date}}. Entre em contato para renovar.",
      reactivate: "Reativar",
      no_plans: "Nenhum plano criado",
      create_plans_hint: "Crie planos para oferecer aos seus clientes",
      status: {
        active: "Ativa",
        cancelled: "Cancelada",
        overdue: "Vencida",
        expiring_in: "Vence em {{days}} dias",
      },
    },
    // Common
    common: {
      save: "Salvar",
      cancel: "Cancelar",
      delete: "Excluir",
      edit: "Editar",
      add: "Adicionar",
      search: "Buscar",
      loading: "Carregando...",
      confirm: "Confirmar",
      back: "Voltar",
      next: "Próximo",
      close: "Fechar",
      yes: "Sim",
      no: "Não",
      all: "Todos",
      none: "Nenhum",
      actions: "Ações",
      view: "Visualizar",
      export: "Exportar",
      import: "Importar",
      filter: "Filtrar",
      clear: "Limpar",
      apply: "Aplicar",
      today: "Hoje",
      yesterday: "Ontem",
      tomorrow: "Amanhã",
      week: "Semana",
      month: "Mês",
      year: "Ano",
      or: "ou",
      and: "e",
      of: "de",
      to: "até",
      from: "de",
      active: "Ativo",
      inactive: "Inativo",
      enabled: "Ativado",
      disabled: "Desativado",
      blocked: "Bloqueado",
      new: "Novo",
      create: "Criar",
      update: "Atualizar",
      refresh: "Atualizar",
      details: "Detalhes",
      status: "Status",
      name: "Nome",
      email: "E-mail",
      phone: "Telefone",
      address: "Endereço",
      date: "Data",
      time: "Horário",
      value: "Valor",
      total: "Total",
      quantity: "Quantidade",
      price: "Preço",
      description: "Descrição",
      notes: "Observações",
      select: "Selecionar",
      selected: "Selecionado",
      confirmed: "confirmados",
      pending: "Pendente",
      completed: "Concluído",
      conversion: "conversão",
      optional: "opcional",
      see_all: "Ver todos",
      see_all_feminine: "Ver todas",
      no_data: "Sem dados",
      income: "Receita",
      expense: "Despesa",
      register_transaction: "Registrar transação",
      more: "mais",
      system: "Sistema",
      user: "Usuário",
      discount: "de desconto",
      min: "Mín.",
      until: "Até",
      color: "Cor",
      preview: "Pré-visualização",
      saving: "Salvando...",
      tags: "Tags",
      copy: "Copiar",
      error: "Erro",
      business: "Negócio",
      other: "Outros",
      type: "Tipo",
      hello: "Olá",
    },

    // Notifications
    notifications: {
      title: "Notificações",
      mark_all_read: "Marcar todas como lidas",
      no_notifications: "Nenhuma notificação",
    },

    // Projects
    projects: {
      subtasks: "Subtarefas",
      subtask_title: "Título da subtarefa",
      no_subtasks: "Nenhuma subtarefa",
      delete_subtask: "Excluir Subtarefa",
      delete_subtask_confirm: "Tem certeza que deseja excluir esta subtarefa?",
    },

    // Units
    units: {
      members: "Membros",
      select_user: "Selecione o usuário",
      choose_user: "Escolha um usuário...",
      no_name: "Sem nome",
      unit_role: "Papel na unidade",
      admin_full_access: "Administrador (acesso total)",
      manager_edit: "Gerente (editar dados)",
      staff_operations: "Funcionário (operações)",
      viewer_readonly: "Visualizador (somente leitura)",
      all_users_members: "Todos os usuários já são membros",
      add_member: "Adicionar Membro",
      current_members: "Membros atuais",
      no_members: "Nenhum membro adicionado",
      add_users_access: "Adicione usuários para dar acesso a esta unidade",
      remove_member_confirm: "Remover este membro da unidade?",
      role_admin: "Administrador",
      role_manager: "Gerente",
      role_staff: "Funcionário",
      role_viewer: "Visualizador",
      manager: "Gerente",
      staff: "Funcionário",
      viewer: "Visualizador",
    },

    // Reminders Module
    reminders: {
      title: "Lembretes",
      subtitle: "Crie lembretes para enviar via WhatsApp, E-mail ou Notificação",
      new_reminder: "Novo Lembrete",
      create_reminder: "Criar Lembrete",
      reminder_title: "Título",
      title_placeholder: "Lembrar de...",
      description_optional: "Descrição (opcional)",
      description_placeholder: "Detalhes do lembrete...",
      datetime: "Data/Hora",
      notification_type: "Tipo de Notificação",
      system_notification: "Notificação no Sistema",
      whatsapp_phone: "Telefone (WhatsApp)",
      phone_placeholder: "+55 (11) 99999-9999",
      email_address: "E-mail",
      email_placeholder: "email@exemplo.com",
      pending: "Pendentes",
      sent: "Enviados",
      all: "Todos",
      no_pending: "Nenhum lembrete pendente",
      no_sent: "Nenhum lembrete enviado",
      no_created: "Nenhum lembrete criado",
      delete_reminder: "Excluir Lembrete",
      delete_confirm: "Tem certeza que deseja excluir este lembrete?",
      send: "Enviar",
      sent_badge: "Enviado",
      whatsapp_sent: "Lembrete enviado via WhatsApp!",
      email_sent: "Lembrete enviado via E-mail!",
      send_error: "Erro ao enviar lembrete: ",
      no_whatsapp_instance: "Nenhuma instância WhatsApp conectada",
      notification_label: "Notificação",
    },

    // Files Module
    files: {
      title: "Arquivos",
      subtitle: "Gerencie seus arquivos e pastas",
      new_folder: "Nova Pasta",
      upload_file: "Enviar Arquivo",
      folder_name: "Nome da Pasta",
      folder_name_placeholder: "Nome da pasta",
      no_files: "Nenhum arquivo",
      no_files_desc: "Faça upload de arquivos ou crie pastas para organizar",
      delete_file: "Excluir Arquivo",
      delete_file_confirm: "Tem certeza que deseja excluir este arquivo? Esta ação não pode ser desfeita.",
      delete_folder: "Excluir Pasta",
      delete_folder_confirm: "Tem certeza que deseja excluir esta pasta? Esta ação não pode ser desfeita.",
      download: "Baixar",
      preview: "Visualizar",
      all_files: "Todos os Arquivos",
      images: "Imagens",
      videos: "Vídeos",
      documents: "Documentos",
      searching: "Buscando...",
      select_folder: "Selecione uma pasta",
      root: "Raiz",
    },

    // Chatbot Module
    chatbot_module: {
      conversations: "Conversas",
      search_conversations: "Buscar conversas...",
      no_conversations: "Nenhuma conversa encontrada",
      unknown: "Desconhecido",
      contact: "Contato",
      human_control: "Controle Humano",
      configure: "Configurar",
      stats: "Estatísticas",
      active: "Ativas",
      waiting: "Aguardando",
      closed: "Encerradas",
      take_over: "Assumir",
      release: "Liberar",
      close_conversation: "Encerrar",
      create_lead: "Criar Lead",
      manage_tags: "Gerenciar Tags",
      no_messages: "Nenhuma mensagem ainda",
      start_conversation: "Inicie a conversa enviando uma mensagem",
      select_conversation: "Selecione uma conversa",
      select_conversation_desc: "Escolha uma conversa à esquerda para visualizar",
      you: "Você",
      bot: "Bot",
    },
    
    // Navigation
    nav: {
      dashboard: "Dashboard",
      agenda: "Agenda",
      clients: "Clientes",
      products: "Produtos",
      services: "Serviços",
      finance: "Financeiro",
      marketing: "Marketing",
      reports: "Relatórios",
      settings: "Configurações",
      help: "Ajuda",
      logout: "Sair",
      pos: "PDV",
      tickets: "Tickets",
      chatbot: "Chatbot IA",
      catalog: "Catálogo",
      module_store: "Loja de Módulos",
      ai_assistant: "Assistente IA",
      
      // Navigation groups
      groups: {
        main: "Principal",
        sales: "Vendas",
        operations: "Operações",
        marketing: "Marketing",
        management: "Gestão",
        intelligence: "Inteligência",
        team: "Equipe",
        online_presence: "Presença Online",
        integrations: "Integrações",
      },
      
      // Navigation items - keys must match NavigationConfig.tsx nameKey values
      items: {
        dashboard: "Dashboard",
        moduleStore: "Loja de Módulos",
        agenda: "Agenda",
        pos: "PDV",
        clients: "Clientes",
        chatbotAI: "Chatbot IA",
        aiAssistant: "Assistente IA",
        crm: "CRM",
        quotes: "Orçamentos",
        contracts: "Contratos",
        subscriptions: "Assinaturas",
        clientPlans: "Planos Clientes",
        packages: "Pacotes",
        catalog: "Catálogo",
        delivery: "Delivery",
        ecommerce: "E-commerce",
        projects: "Projetos",
        reminders: "Lembretes",
        inventory: "Estoque",
        checklists: "Checklists",
        tickets: "Tickets",
        passwordPanel: "Painel de Senhas",
        resourceBooking: "Reserva Recursos",
        fiscalNotes: "Fiscal & Notas",
        medicalRecords: "Prontuário",
        workouts: "Treinos",
        realEstate: "Imobiliária",
        campaigns: "Campanhas",
        whatsappGroups: "Grupos WhatsApp",
        automations: "Automações",
        loyalty: "Fidelidade",
        nps: "NPS",
        satisfaction: "Satisfação",
        reviews: "Avaliações",
        referrals: "Indicações",
        reactivation: "Reativação",
        financial: "Financeiro",
        commissions: "Comissões",
        goals: "Metas",
        reports: "Relatórios",
        aiPro: "IA Pro",
        leadHunter: "Lead Hunter",
        funnelAnalytics: "Analytics Funil",
        aiCompetitors: "IA Concorrentes",
        aiPricing: "IA Precificação",
        aiInsights: "Insights IA",
        aiCopy: "IA Copy",
        communication: "Comunicação",
        learning: "Aprendizado",
        forms: "Formulários",
        library: "Biblioteca",
        peopleManagement: "Gestão de Pessoas",
        myLinks: "Meus Links",
        miniSite: "Mini Site",
        clientPortal: "Portal Cliente",
        webhooks: "Webhooks",
        apiKeys: "API Keys",
        settings: "Configurações",
        onlinePresence: "Presença Online",
      },
    },
    
    // Dashboard
    dashboard: {
      welcome: "Olá, {{name}}!",
      summary: "Aqui está o resumo do seu dia.",
      summary_with_appointments: "Aqui está o resumo do seu dia. Você tem {{count}} agendamento(s) hoje.",
      monthly_revenue: "Faturamento Mensal",
      appointments_today: "Agendamentos Hoje",
      pending_tasks: "Tarefas Pendentes",
      active_clients: "Clientes Ativos",
      upcoming_appointments: "Próximos Agendamentos",
      recent_transactions: "Movimentações Recentes",
      transactions: "Movimentações",
      no_appointments: "Nenhum agendamento próximo",
      create_appointment: "Criar agendamento",
      new_this_month: "novos este mês",
      this_month: "este mês",
      no_movements: "Nenhuma movimentação recente",
      no_movements_short: "Nenhuma movimentação",
      see_all: "Ver todos",
      quick_actions: "Ações Rápidas",
      alerts: "Alertas",
      vip_inactive: "VIPs inativos há 30 dias",
      pending_leads: "leads aguardando ação",
      financial_overview: "Visão Financeira",
      no_data_yet: "Sem dados ainda",
      add_first_sale: "Adicione sua primeira venda",
      next_available_time: "Próximo horário disponível a partir das próximas horas",
      
      // Stats
      confirmed: "confirmados",
      none: "Nenhum",
      
      // Alerts
      top_inactive_clients: "Clientes Top Inativos",
      click_to_see_details: "Clique para ver detalhes",
      pending_leads_count: "Leads Pendentes",
      click_to_see_pipeline: "Clique para ver pipeline",
      inactive_clients: "Clientes Inativos",
      click_to_reactivate: "Clique para reativar",
      
      // Suggestions
      automatic_suggestions: "Sugestões Automáticas",
      reactivate_inactive: "Reativar Clientes Inativos",
      clients_not_buying: "clientes não compram há mais de 30 dias",
      inactive_vip_clients: "Clientes VIP Inativos",
      vip_need_attention: "clientes VIP precisam de atenção",
      create_special_coupon: "Criar Cupom Especial",
      increase_engagement: "Aumente o engajamento com uma oferta exclusiva",
      pending_proposals: "Propostas Pendentes",
      opportunities_awaiting: "oportunidades aguardando follow-up",
      create_campaign: "Criar Campanha",
      send_offer: "Enviar Oferta",
      create_coupon: "Criar Cupom",
      see_pipeline: "Ver Pipeline",
      
      // Appointment status
      status: {
        confirmed: "Confirmado",
        scheduled: "Agendado",
        completed: "Concluído",
        cancelled: "Cancelado",
      },
      
      // Client info
      client_not_informed: "Cliente não informado",
      service_not_informed: "Serviço não informado",
    },
    
    // Quick Actions
    quick_actions: {
      title: "Ações Rápidas",
      schedule: "Agendar",
      new_client: "Novo Cliente",
      register_sale: "Registrar Venda",
      send_campaign: "Enviar Campanha",
      new_appointment: "Novo Agendamento",
      client: "Cliente",
      service: "Serviço",
      professional: "Profissional",
      date_time: "Data e Hora",
      select_client: "Selecione o cliente",
      select_service: "Selecione o serviço",
      select_professional: "Selecione o profissional",
      client_name: "Nome do cliente",
      sale_description: "Descrição da venda",
      register: "Registrar",
      create: "Criar",
      fill_required: "Preencha todos os campos obrigatórios",
      name_required: "Nome é obrigatório",
      fill_value_description: "Preencha valor e descrição",
      appointment_created: "Agendamento criado com sucesso!",
      appointment_error: "Erro ao criar agendamento",
      client_created: "Cliente cadastrado com sucesso!",
      client_error: "Erro ao cadastrar cliente",
      sale_created: "Venda registrada com sucesso!",
      sale_error: "Erro ao registrar venda",
    },
    
    // Agenda
    agenda: {
      title: "Agenda",
      subtitle: "Gerencie seus agendamentos",
      new_appointment: "Novo Agendamento",
      select_client: "Selecione o cliente",
      select_service: "Selecione o serviço",
      select_professional: "Selecione o profissional",
      select_time: "Selecione o horário",
      notes: "Observações",
      day: "Dia",
      week: "Semana",
      calendar: "Calendário",
      online_booking: "Agendamento Online",
      waiting_list: "Lista de Espera",
      widget: "Widget",
      settings: "Configurações",
      filter_by_professional: "Filtrar por profissional",
      all_professionals: "Todos",
      no_appointments_day: "Nenhum agendamento neste dia",
      quick_customer: "Cadastro Rápido",
      continue_booking: "Continue o agendamento",
      customer_name_required: "Nome do cliente é obrigatório",
      customer_registered: "Cliente cadastrado! Agora continue com o agendamento.",
      fill_required: "Preencha todos os campos obrigatórios",
      appointment_created: "Agendamento criado com sucesso!",
      select_professional_confirm: "Selecione um profissional",
      appointment_details: "Detalhes do Agendamento",
      send_confirmation: "Enviar Confirmação",
      confirmation_sent: "Mensagem de confirmação enviada para {{name}}!",
      reschedule: "Reagendar",
      cancel_appointment: "Cancelar Agendamento",
      cancel_confirm: "Tem certeza que deseja cancelar este agendamento?",
      cancel_irreversible: "Esta ação não pode ser desfeita.",
      keep: "Manter",
      confirm_cancel: "Sim, cancelar",
      cancelled_success: "Agendamento cancelado!",
      cancellation_sent: "Mensagem de cancelamento enviada para {{name}}!",
      reschedule_appointment: "Reagendar Agendamento",
      new_date: "Nova Data",
      new_time: "Novo Horário",
      confirm_reschedule: "Confirmar Reagendamento",
      rescheduled_success: "Agendamento reagendado!",
      reschedule_sent: "Mensagem de reagendamento enviada para {{name}}!",
      complete_appointment: "Finalizar Atendimento",
      use_loyalty_points: "Usar pontos de fidelidade",
      available_points: "{{points}} pontos disponíveis",
      use_cashback: "Usar cashback",
      available_cashback: "{{amount}} disponível",
      confirm_complete: "Confirmar e Finalizar",
      loyalty_redeemed: "Fidelidade resgatada!",
      points_used: "{{points}} pontos utilizados",
      cashback_used: "{{amount}} de cashback utilizado",
      meeting_result: "Resultado da Reunião",
      select_outcome: "Selecione o resultado",
      outcome_contact: "Contato realizado",
      outcome_proposal: "Proposta enviada",
      outcome_negotiation: "Em negociação",
      outcome_closed_won: "Fechado - Ganho",
      outcome_closed_lost: "Fechado - Perdido",
      update_deal: "Atualizar Negócio",
      deal_updated: "Status do negócio atualizado!",
      copy_link: "Copiar Link",
      link_copied: "Link copiado!",
      open_meet: "Abrir Meet",
      status: {
        scheduled: "Agendado",
        confirmed: "Confirmado",
        completed: "Concluído",
        cancelled: "Cancelado",
        no_show: "Não compareceu",
      },
      status_updated: "Status atualizado para {{status}}",
      package_warning: "Aviso de Pacote",
      understood: "Entendido",
      weekdays: {
        sun: "Dom",
        mon: "Seg",
        tue: "Ter",
        wed: "Qua",
        thu: "Qui",
        fri: "Sex",
        sat: "Sáb",
      },
    },
    
    // Clients
    clients: {
      title: "Clientes",
      subtitle: "Gerencie seus clientes e etiquetas",
      new_client: "Novo Cliente",
      edit_client: "Editar Cliente",
      update_client_desc: "Atualize os dados do cliente",
      new_client_desc: "Preencha os dados para cadastrar um novo cliente",
      total: "Total de Clientes",
      new_this_month: "Novos este mês",
      average_ticket: "Ticket Médio",
      return_rate: "Taxa de Retorno",
      name: "Nome",
      name_placeholder: "Nome completo",
      email: "E-mail",
      phone: "Telefone",
      birthday: "Data de Nascimento",
      notes: "Observações",
      notes_placeholder: "Notas sobre o cliente",
      tags: "Tags",
      tags_tab: "Etiquetas",
      last_visit: "Última visita",
      total_spent: "Total gasto",
      visits: "visitas",
      search_placeholder: "Buscar por nome, e-mail ou telefone...",
      all_tags: "Todas",
      no_clients: "Nenhum cliente encontrado",
      try_different_search: "Tente uma busca diferente",
      register_first_client: "Cadastre seu primeiro cliente para começar",
      client: "Cliente",
      contact: "Contato",
      loyalty: "Fidelidade",
      cpf_cnpj: "CPF/CNPJ",
      cpf_cnpj_placeholder: "000.000.000-00 ou 00.000.000/0000-00",
      lookup_cnpj: "Buscar CNPJ",
      lookup_cnpj_auto: "Clique no ícone para buscar dados do CNPJ automaticamente",
      cpf_cnpj_hint: "Digite CPF (11 dígitos) ou CNPJ (14 dígitos)",
      invalid_cpf: "CPF inválido",
      invalid_cnpj: "CNPJ inválido",
      cpf_cnpj_length_error: "CPF deve ter 11 dígitos ou CNPJ deve ter 14 dígitos",
      enter_valid_cnpj: "Digite um CNPJ válido (14 dígitos) para consultar",
      select_tags: "Selecione as tags",
      no_tags_created: "Nenhuma etiqueta cadastrada. Crie etiquetas na aba \"Etiquetas\".",
      name_required: "Nome é obrigatório",
      client_updated: "Cliente atualizado com sucesso!",
      client_created: "Cliente cadastrado com sucesso!",
      confirm_delete: "Excluir cliente",
      confirm_delete_message: "Tem certeza que deseja excluir {{name}}? Esta ação não pode ser desfeita.",
      client_deleted: "Cliente excluído com sucesso!",
      clients_deleted: "{{count}} cliente(s) excluído(s)",
      send_whatsapp: "Enviar WhatsApp",
      no_phone: "Cliente não possui telefone cadastrado.",
      no_whatsapp_instance: "Nenhuma instância WhatsApp conectada. Configure em Configurações > Integrações.",
      enter_message: "Digite uma mensagem.",
      message_sent: "Mensagem enviada para {{name}}!",
      error_sending: "Erro ao enviar mensagem.",
      view_profile: "Ver Perfil",
      view_details: "Ver detalhes",
      loyalty_points: "Pontos",
      cashback: "Cashback",
      history: "Histórico",
      appointments: "Agendamentos",
      transactions: "Transações",
    },
    
    // Finance
    finance: {
      title: "Financeiro",
      subtitle: "Visão geral do seu fluxo de caixa",
      income: "Receitas",
      income_month: "Receitas (mês)",
      expenses: "Despesas",
      expenses_month: "Despesas (mês)",
      balance: "Saldo",
      new_transaction: "Nova Transação",
      edit_transaction: "Editar Transação",
      type: "Tipo",
      amount: "Valor",
      description: "Descrição",
      category: "Categoria",
      payment_method: "Forma de Pagamento",
      date: "Data",
      due_date: "Data de Vencimento",
      status: "Status",
      overview: "Visão Geral",
      dre: "DRE",
      forecast: "Previsão IA",
      income_vs_expenses: "Receitas x Despesas",
      recent_transactions: "Últimas Transações",
      no_transactions: "Nenhuma transação encontrada",
      no_data: "Nenhum dado disponível",
      view_all: "Ver todas",
      view_less: "Ver menos",
      scan_receipt: "Escanear Cupom Fiscal com IA",
      create_transaction: "Criar Transação",
      update_transaction: "Atualizar Transação",
      confirm_delete: "Excluir transação",
      confirm_delete_message: "Tem certeza que deseja excluir esta transação?",
      transaction_deleted: "Transação excluída!",
      transaction_updated: "Transação atualizada!",
      payment_status: {
        paid: "Pago",
        pending: "Pendente",
        overdue: "Atrasado",
      },
      categories: {
        service: "Serviço",
        product: "Produto",
        other: "Outros",
        supplier: "Fornecedor",
        rent: "Aluguel",
        salaries: "Salários",
        marketing: "Marketing",
        equipment: "Equipamentos",
      },
      payment_methods: {
        cash: "Dinheiro",
        credit_card: "Cartão Crédito",
        debit_card: "Cartão Débito",
        pix: "PIX",
        transfer: "Transferência",
        boleto: "Boleto",
      },
    },
    
    // Products/Inventory
    products: {
      title: "Estoque",
      subtitle: "Gerencie seus produtos e movimentações",
      new_product: "Novo Produto",
      edit_product: "Editar Produto",
      total: "Total",
      active: "Ativos",
      low_stock: "Estoque Baixo",
      total_value: "Valor Total",
      low_stock_alert: "Produtos com Estoque Baixo",
      no_products: "Nenhum produto encontrado",
      search_placeholder: "Buscar por nome ou código...",
      all_categories: "Todas categorias",
      name: "Nome",
      sku: "SKU",
      code: "Código",
      category: "Categoria",
      cost_price: "Preço de Custo",
      sale_price: "Preço de Venda",
      stock: "Estoque",
      initial_stock: "Estoque Inicial",
      min_alert: "Alerta Mínimo",
      unit: "Unidade",
      description: "Descrição",
      image: "Imagem",
      visible_catalog: "Visível no Catálogo",
      create_product: "Criar Produto",
      update_product: "Atualizar Produto",
      product_created: "Produto criado com sucesso!",
      product_updated: "Produto atualizado com sucesso!",
      product_deleted: "Produto excluído com sucesso!",
      error_creating: "Erro ao criar produto",
      error_updating: "Erro ao atualizar produto",
      error_deleting: "Erro ao excluir produto",
      entry: "Entrada",
      exit: "Saída",
      register_entry: "Registrar Entrada",
      register_exit: "Registrar Saída",
      movement_history: "Histórico de Movimentações",
      quantity: "Quantidade",
      unit_cost: "Custo Unitário",
      movement_description: "Descrição",
      register_movement: "Registrar",
      entry_registered: "Entrada registrada!",
      exit_registered: "Saída registrada!",
      error_movement: "Erro ao registrar movimentação",
      no_movements: "Nenhuma movimentação encontrada",
      units: {
        un: "Unidade",
        ml: "Mililitro",
        g: "Grama",
        kg: "Quilograma",
        l: "Litro",
      },
    },
    
    // Marketing
    marketing: {
      title: "Marketing",
      subtitle: "Crie campanhas e engaje seus clientes",
      new_campaign: "Nova Campanha",
      generate_with_ai: "Gerar com IA",
      campaign_name: "Nome da Campanha",
      email_subject: "Assunto do E-mail",
      target_audience: "Público-alvo",
      message: "Mensagem",
      email: "E-mail",
      whatsapp: "WhatsApp",
      all_clients: "Todos os clientes",
      new_clients: "Novos clientes (último mês)",
      birthday_month: "Aniversariantes do mês",
      inactive_clients: "Clientes inativos (3+ meses)",
      by_tags: "Por Tags/Etiquetas",
      select_tags: "Selecione as Tags",
      no_tags: "Nenhuma tag criada. Crie tags em \"Tags/Etiquetas\".",
      templates: "Modelos",
      use_variables: "Use {nome} para personalização",
      save_draft: "Salvar Rascunho",
      schedule: "Agendar",
      send_now: "Enviar Agora",
      all_campaigns: "Todas",
      email_campaigns: "E-mail",
      whatsapp_campaigns: "WhatsApp",
      search_campaigns: "Buscar campanhas...",
      filter_status: "Filtrar status",
      all_statuses: "Todos os status",
      status: {
        sent: "Enviado",
        sending: "Enviando...",
        scheduled: "Agendado",
        draft: "Rascunho",
        failed: "Falhou",
      },
      recipients: "destinatários",
      no_email_clients: "Nenhum cliente com e-mail no público selecionado",
      no_whatsapp_instance: "Nenhuma instância WhatsApp conectada",
      configure_whatsapp: "Configure uma instância em Configurações > Integrações",
      no_phone_clients: "Nenhum cliente com telefone no público selecionado",
      fill_required: "Preencha os campos obrigatórios",
      fill_email_subject: "Preencha o assunto do e-mail",
      campaign_sent: "Campanha enviada para {{count}} cliente(s)!",
      send_error: "Erro ao enviar campanha",
      draft_saved: "Rascunho salvo!",
      campaign_scheduled: "Campanha agendada!",
      no_campaigns: "Nenhuma campanha ainda",
      start_first_campaign: "Comece criando sua primeira campanha",
    },
    
    // CRM
    crm: {
      title: "CRM",
      subtitle: "Pipeline de vendas e oportunidades",
      new_opportunity: "Nova Oportunidade",
      ai_insights: "Insights IA",
      lead_scoring: "Lead Scoring",
      manage_stages: "Gerenciar Etapas",
      opportunity_title: "Título",
      value: "Valor",
      priority: "Prioridade",
      client: "Cliente",
      expected_close: "Previsão de Fechamento",
      description: "Descrição",
      create_opportunity: "Criar Oportunidade",
      search_opportunities: "Buscar oportunidades...",
      filter_priority: "Filtrar prioridade",
      all_priorities: "Todas prioridades",
      smart_suggestions: "Sugestões Inteligentes",
      inactive_clients_coupon: "clientes inativos - Enviar cupom",
      pending_proposals_reminder: "propostas pendentes - Relembrar",
      create_exclusive_package: "Criar pacote exclusivo Top 10",
      open: "Em Aberto",
      won: "Ganhos",
      conversion: "Conversão",
      closed_revenue: "Receita Fechada",
      no_opportunities: "Sem oportunidades",
      drag_drop_hint: "Arraste os cards para mover entre etapas",
      stage_settings: "Configurar Etapas",
      stage_name: "Nome da Etapa",
      stage_color: "Cor",
      add_stage: "Adicionar Etapa",
      edit_stage: "Editar Etapa",
      delete_stage: "Excluir Etapa",
      delete_stage_confirm: "Tem certeza que deseja excluir a etapa \"{{name}}\"?",
      delete_stage_warning: "Os negócios nesta etapa serão movidos para \"Lead\".",
      priority_high: "Alta",
      priority_medium: "Média",
      priority_low: "Baixa",
      none: "Nenhum",
      select_client: "Selecione um cliente",
    },
    
    // Reports
    reports: {
      title: "Relatórios",
      subtitle: "Análise de desempenho do seu negócio",
      export_pdf: "Exportar PDF",
      exporting: "Exportando...",
      pdf_exported: "PDF exportado com sucesso!",
      pdf_error: "Erro ao exportar PDF",
      new_widget: "Novo Widget",
      overview: "Visão Geral",
      my_charts: "Meus Gráficos",
      financial_report_title: "Relatório Financeiro",
      no_widgets: "Nenhum widget criado",
      create_widgets_desc: "Crie gráficos personalizados para acompanhar suas métricas",
      create_widget: "Criar Widget",
      top_clients: "Melhores Clientes",
      no_clients: "Nenhum cliente cadastrado",
      visits: "visitas",
      total_spent: "total gasto",
      monthly_revenue_chart: "Faturamento Mensal",
      positive: "Positivo",
      negative: "Negativo",
      agenda_report: "Relatório de Agenda",
      agenda_report_desc: "Taxa de ocupação, horários mais procurados e no-shows.",
      financial_report: "Relatório Financeiro",
      financial_report_desc: "DRE, fluxo de caixa e análise de despesas.",
      marketing_report: "Relatório de Marketing",
      marketing_report_desc: "Campanhas enviadas, taxas de abertura e conversões.",
      agenda_analysis: "Análise completa dos agendamentos",
      financial_analysis: "Análise completa das finanças",
      marketing_analysis: "Análise das campanhas de marketing",
      kpis: {
        monthly_revenue: "Faturamento Mensal",
        avg_ticket: "Ticket Médio",
        appointments_today: "Agendamentos Hoje",
        total_clients: "Total de Clientes",
        expenses_month: "Despesas Mês",
        net_profit: "Lucro Líquido",
      },
      agenda: {
        total_appointments: "Total de Agendamentos",
        occupancy_rate: "Taxa de Ocupação",
        cancellations: "Cancelamentos",
        no_shows: "No-shows",
        no_show: "Não compareceu",
        completed: "Concluídos",
        cancelled: "Cancelados",
        status: "Status dos Agendamentos",
      },
      financial: {
        dre: "DRE Simplificado",
        revenue: "Receitas",
        expenses: "Despesas",
        net_profit: "Lucro Líquido",
        expenses_by_category: "Despesas por Categoria",
      },
      marketing: {
        total_contacts: "Total de Contatos",
        campaigns_sent: "Campanhas Enviadas",
        open_rate: "Taxa de Abertura",
        click_rate: "Taxa de Clique",
        email_marketing: "E-mail Marketing",
        whatsapp_marketing: "WhatsApp Marketing",
        emails_sent: "e-mails enviados",
        messages_sent: "mensagens enviadas",
        create_campaigns: "Crie campanhas de marketing para ver análises detalhadas",
      },
    },
    
    // Loyalty
    loyalty: {
      title: "Fidelidade",
      subtitle: "Programa de pontos, cashback e cupons",
      points_issued: "Pontos Emitidos",
      available_cashback: "Cashback Disponível",
      active_coupons: "Cupons Ativos",
      config: "Configurações",
      coupons: "Cupons",
      customers: "Clientes",
      loyalty_program: "Programa de Fidelidade",
      program_rules: "Configure as regras de pontos e cashback",
      program_active: "Programa Ativo",
      program_active_desc: "Ativar ou desativar o programa de fidelidade",
      points_per_currency: "Pontos por R$ 1,00",
      points_per_currency_hint: "Ex: 0.1 = 1 ponto a cada R$ 10,00",
      cashback_percent: "Cashback (%)",
      cashback_percent_hint: "Porcentagem de cashback sobre compras",
      expiration_days: "Expiração dos Pontos (dias)",
      expiration_days_hint: "Deixe vazio para não expirar",
      never_expires: "Nunca expira",
      save_config: "Salvar Configurações",
      search_coupon: "Buscar cupom...",
      all: "Todos",
      active: "Ativos",
      expired: "Expirados",
      exhausted: "Esgotados",
      inactive: "Inativos",
      new_coupon: "Novo Cupom",
      create_coupon: "Criar Cupom",
      code: "Código",
      generate: "Gerar",
      discount_type: "Tipo de Desconto",
      percent: "Porcentagem (%)",
      fixed: "Valor Fixo (R$)",
      discount_value: "Valor",
      min_amount: "Valor Mínimo (R$)",
      max_uses: "Máximo de Usos",
      unlimited: "Ilimitado",
      valid_until: "Válido Até",
      no_coupons: "Nenhum cupom criado",
      no_coupons_found: "Nenhum cupom encontrado",
      code_required: "Digite o código do cupom",
      code_copied: "Código copiado!",
      uses: "usos",
      clients_with_loyalty: "Clientes com Fidelidade",
      search_client: "Buscar cliente...",
      points: "Pontos",
      cashback: "Cashback",
      no_clients_loyalty: "Nenhum cliente acumulou pontos ou cashback ainda.",
    },
    
    // Settings
    settings: {
      title: "Configurações",
      subtitle: "Gerencie as configurações do seu negócio",
      business: "Negócio",
      services: "Serviços",
      team: "Equipe",
      integrations: "Integrações",
      notifications: "Notificações",
      billing: "Assinatura",
      units: "Unidades",
      
      // Language
      language: "Idioma",
      language_title: "Idioma do Sistema",
      language_description: "Escolha o idioma da interface",
      
      // Profile
      profile_photo: "Foto de Perfil",
      profile_photo_desc: "Esta foto será exibida na comunicação interna e no seu perfil",
      change_photo: "Alterar foto",
      uploading: "Enviando...",
      
      // Business
      business_data: "Dados do Negócio",
      business_data_desc: "Informações que aparecem para seus clientes",
      business_name: "Nome do Negócio",
      phone_with_ddi: "Telefone (com DDI)",
      address: "Endereço",
      address_placeholder: "Rua, número, bairro, cidade - UF",
      cnpj: "CNPJ",
      slug: "Link personalizado",
      slug_desc: "Este slug será usado nas URLs públicas do catálogo, agendamento e linktree",
      save_data: "Salvar Alterações",
      public_url: "URL pública",
      
      // Hours
      hours: "Horários",
      hours_title: "Horário de Funcionamento",
      hours_desc: "Configure os dias e horários de atendimento",
      start_time: "Início",
      end_time: "Término",
      working_days: "Dias de Funcionamento",
      save_hours: "Salvar Horários",
      
      // Weekdays
      weekdays: {
        sun: "Dom",
        mon: "Seg",
        tue: "Ter",
        wed: "Qua",
        thu: "Qui",
        fri: "Sex",
        sat: "Sáb",
      },
      
      // Notifications
      push_notifications: "Notificações Push",
      push_notifications_desc: "Receba lembretes de agendamentos diretamente no navegador",
      notifications_active: "Notificações ativas",
      notifications_active_desc: "Você receberá lembretes de agendamentos",
      notifications_blocked: "Notificações foram bloqueadas pelo navegador. Para ativar, acesse as configurações do seu navegador → Privacidade e segurança → Configurações de site → Notificações, e permita notificações para este site.",
      notifications_not_supported: "Seu navegador não suporta notificações push",
      notifications_not_supported_desc: "Para receber notificações, use um navegador moderno como Chrome, Firefox, Edge ou Safari.",
      enable_notifications: "Ativar Notificações",
      reminder_15min: "Lembrete 15 min antes",
      reminder_30min: "Lembrete 30 min antes",
      new_appointments_notif: "Novos agendamentos",
      
      // Email notifications
      email_notifications: "Notificações por E-mail",
      email_notifications_desc: "Configure as notificações que você recebe por e-mail",
      email_new_appointments: "E-mail de novos agendamentos",
      email_new_appointments_desc: "Receber quando um cliente agendar",
      appointment_reminders: "Lembretes de agenda",
      appointment_reminders_desc: "Alerta 15min antes do atendimento",
      weekly_report: "Relatório semanal",
      weekly_report_desc: "Resumo de performance toda segunda",
      low_stock_alerts: "Alertas de estoque baixo",
      low_stock_alerts_desc: "Quando produtos estiverem acabando",
      save_notifications: "Salvar Notificações",
    },
    
    // Auth
    auth: {
      login: "Entrar",
      register: "Criar Conta",
      logout: "Sair",
      email: "E-mail",
      password: "Senha",
      confirm_password: "Confirmar Senha",
      forgot_password: "Esqueceu a senha?",
      reset_password: "Redefinir Senha",
      full_name: "Nome Completo",
      already_have_account: "Já tem uma conta?",
      dont_have_account: "Não tem uma conta?",
      or_continue_with: "ou continue com",
      logging_in: "Entrando...",
      creating_account: "Criando conta...",
    },
    
    // Languages
    languages: {
      pt: "Português",
      en: "English",
      es: "Español",
    },
    
    // Errors
    errors: {
      generic: "Ocorreu um erro. Tente novamente.",
      required_field: "Este campo é obrigatório",
      invalid_email: "E-mail inválido",
      invalid_phone: "Telefone inválido",
      photo_update_error: "Erro ao atualizar foto",
    },
    
    // Success messages
    success: {
      saved: "Salvo com sucesso!",
      deleted: "Excluído com sucesso!",
      updated: "Atualizado com sucesso!",
      photo_updated: "Foto de perfil atualizada!",
      hours_saved: "Horários salvos com sucesso!",
      notifications_saved: "Preferências de notificação salvas!",
    },

    // Changelog
    changelog: {
      title: "Novidades",
      loading: "Carregando...",
      no_updates: "Nenhuma atualização disponível",
      new: "Novo",
      improvement: "Melhoria",
      fix: "Correção",
    },

    // Insights
    insights: {
      title: "Insights por IA",
      subtitle: "Análises inteligentes e sugestões para seu negócio",
      generate: "Gerar Insights",
      analyzing: "Analisando...",
      active_insights: "Insights Ativos",
      high_priority: "Alta Prioridade",
      about_revenue: "Sobre Receita",
      dismissed: "Descartados",
      search_placeholder: "Buscar insights...",
      filter_type: "Tipo",
      filter_priority: "Prioridade",
      all_types: "Todos os tipos",
      revenue: "Receita",
      customers: "Clientes",
      appointments: "Agendamentos",
      inventory: "Estoque",
      alerts: "Alertas",
      all_priorities: "Todas",
      high: "Alta",
      medium: "Média",
      low: "Baixa",
      loading: "Carregando insights...",
      no_insights: "Nenhum insight disponível",
      no_insights_found: "Nenhum insight encontrado",
      no_insights_desc: "Clique em \"Gerar Insights\" para que a IA analise seus dados e sugira melhorias para o seu negócio.",
      adjust_filters: "Tente ajustar os filtros",
      dismiss_insight: "Descartar insight",
      generated_at: "Gerado em",
      dismissed_insights: "Insights Descartados",
    },

    // PDV
    pdv: {
      title: "PDV",
      subtitle: "Ponto de venda rápido",
      quick_sale: "Venda Rápida",
      tables: "Mesas",
      wristbands: "Pulseiras",
      cash_open: "Caixa Aberto",
      open_cash: "Abrir Caixa",
      quick_links: "Links Rápidos:",
      waiter_tables: "Garçom - Mesas",
      waiter_wristbands: "Garçom - Pulseiras",
      security: "Segurança",
      kitchen: "Cozinha",
      search_placeholder: "Buscar produto ou serviço...",
      products: "Produtos",
      services: "Serviços",
      all: "Todos",
      no_items: "Nenhum item encontrado",
      out_of_stock: "Produto sem estoque",
      insufficient_stock: "Estoque insuficiente",
      max_available: "Quantidade máxima disponível",
      cart: "Carrinho",
      customer: "Cliente (opcional)",
      no_customer: "Sem cliente",
      select_customer: "Selecionar cliente",
      search_customer: "Buscar cliente...",
      no_customer_found: "Nenhum cliente encontrado.",
      empty_cart: "Carrinho vazio",
      discount: "Desconto (R$)",
      payment_method: "Forma de pagamento",
      cash: "Dinheiro",
      credit_card: "Cartão Crédito",
      debit_card: "Cartão Débito",
      pix: "PIX",
      subtotal: "Subtotal",
      total: "Total",
      finalize_sale: "Finalizar Venda",
      processing: "Processando...",
      sale_completed: "Venda Concluída!",
      no_sku: "Sem SKU",
      without_stock: "Sem estoque",
    },

    // Clinic
    clinic: {
      title: "Clínica",
      subtitle: "Prontuário eletrônico, anamnese e evolução clínica",
      patients: "Pacientes",
      records: "Prontuários",
      evolutions: "Evoluções",
      photos: "Fotos",
      search_patient: "Buscar paciente...",
      no_patients: "Nenhum paciente encontrado",
      record: "Prontuário",
      last_appointment: "Último atendimento",
      no_contact: "Sem contato",
      select_patient: "Selecione um paciente para ver o prontuário",
      new_anamnesis: "Nova Anamnese",
      new_evolution: "Nova Evolução",
      suggest_treatment: "Sugerir Tratamento",
      anamnesis: "Anamnese",
      prescription: "Prescrição",
      evolution: "Evolução",
      exam: "Exame",
      consent: "Consentimento",
      chief_complaint: "Queixa Principal",
      chief_complaint_placeholder: "Descreva a queixa principal do paciente...",
      medical_history: "Histórico Médico",
      medical_history_placeholder: "Doenças prévias, cirurgias, internações...",
      allergies: "Alergias",
      allergies_placeholder: "Medicamentos, alimentos, outros...",
      medications: "Medicamentos em Uso",
      medications_placeholder: "Liste os medicamentos...",
      family_history: "Histórico Familiar",
      family_history_placeholder: "Doenças na família...",
      lifestyle: "Hábitos e Estilo de Vida",
      lifestyle_placeholder: "Tabagismo, etilismo, atividade física...",
      save_anamnesis: "Salvar Anamnese",
      ai_suggestion: "Sugestão IA",
      not_informed: "Não informado",
      appointments_count: "Atendimentos",
      records_count: "Registros",
      clinical_history: "Histórico Clínico",
      no_records: "Nenhum registro encontrado",
      no_records_desc: "Crie uma anamnese ou evolução para começar",
      appointment: "Atendimento",
      no_notes: "Sem observações registradas",
      see_details: "Ver Detalhes",
      clinical_evolutions: "Evoluções Clínicas",
      select_patient_evolutions: "Selecione um paciente e registre evoluções",
      evolution_photos: "Fotos de Evolução",
      add_photo: "Adicionar Foto",
      no_photos: "Nenhuma foto de evolução registrada",
      no_photos_desc: "Adicione fotos antes/depois para acompanhar a evolução do tratamento",
      new_clinical_evolution: "Nova Evolução Clínica",
      patient: "Paciente",
      select_patient_form: "Selecione o paciente...",
      title_field: "Título",
      title_placeholder: "Ex: Retorno - Avaliação",
      evolution_field: "Evolução",
      evolution_placeholder: "Descreva a evolução do paciente...",
      save_evolution: "Salvar Evolução",
      ai_suggestion_title: "Sugestão da IA",
      select_patient_first: "Selecione um paciente primeiro.",
      ai_error: "Erro ao processar sugestão com IA.",
    },

    // Header
    header: {
      notifications: "Notificações",
      mark_all: "Marcar todas",
      no_notifications: "Nenhuma notificação",
      search_placeholder: "Buscar... (Ctrl+K)",
      expand_menu: "Expandir menu",
      collapse_menu: "Minimizar menu",
      my_profile: "Meu Perfil",
      subscription: "Assinatura",
      admin_panel: "Painel Admin",
      help_center: "Central de Ajuda",
      support: "Suporte",
      logout: "Sair",
    },

    // Quick Replies (Chatbot)
    quick_replies: {
      title: "Respostas Rápidas",
      description: "Configure mensagens pré-definidas para agilizar o atendimento",
      new_reply: "Nova Resposta",
      edit_reply: "Editar Resposta Rápida",
      title_shortcut: "Título (atalho)",
      title_placeholder: "Ex: Saudação, Agradecimento, Horário...",
      title_help: "Um nome curto para identificar a resposta",
      message: "Mensagem",
      message_placeholder: "Ex: Olá! Obrigado por entrar em contato. Como posso ajudar?",
      message_help: "A mensagem completa que será enviada",
      saving: "Salvando...",
      no_replies: "Nenhuma resposta rápida criada",
      no_replies_desc: "Crie respostas para agilizar seu atendimento",
      confirm_delete: "Tem certeza que deseja excluir esta resposta rápida?",
      title_message_required: "Título e mensagem são obrigatórios",
    },

    // Agenda Banners
    agenda_banners: {
      title: "Banners da Agenda",
      description: "Adicione banners promocionais que serão exibidos na página de agenda",
      add: "Adicionar",
      edit_banner: "Editar Banner",
      title_optional: "Título (opcional)",
      title_placeholder: "Ex: Promoção de Verão",
      link_optional: "Link (opcional)",
      apply: "Aplicar",
      save_banners: "Salvar Banners",
      image_uploaded: "Imagem carregada! Salve para aplicar.",
      upload_error: "Erro ao fazer upload",
    },

    // PDV Tables
    pdv_tables: {
      table: "Mesa",
      tables: "Mesas",
      manage_tables: "Gerenciar Mesas",
      new_table: "Nova Mesa",
      create_table: "Criar Mesa",
      table_number: "Número da Mesa",
      table_name: "Nome (opcional)",
      capacity: "Capacidade",
      people: "pessoas",
      available: "Disponível",
      occupied: "Ocupada",
      reserved: "Reservada",
      open_table: "Abrir Mesa",
      close_table: "Fechar Mesa",
      table_closed: "Mesa Fechada!",
      back: "Voltar",
      opened: "Aberta",
      order: "Comanda",
      no_items: "Nenhum item",
      search_item: "Buscar item...",
      products: "Produtos",
      services: "Serviços",
      qr_codes: "QR Codes",
      download_qr: "Baixar QR",
      print_all: "Imprimir Todos",
      customer: "Cliente",
      search_customer: "Buscar cliente...",
      no_customer_found: "Nenhum cliente encontrado",
      new_customer: "Novo Cliente",
      register_customer: "Cadastrar Cliente",
      name_required: "Nome é obrigatório",
      customer_registered: "Cliente cadastrado!",
      customer_error: "Erro ao cadastrar cliente",
      confirm_open: "Confirmar Abertura",
      no_tables: "Nenhuma mesa cadastrada",
      create_first_table: "Crie a primeira mesa",
      delete_confirm: "Excluir mesa",
    },

    // Cash Register
    cash_register: {
      title: "Controle de Caixa",
      description: "Gerencie a abertura, fechamento e movimentações do caixa",
      current: "Atual",
      movements: "Movimentações",
      history: "Histórico",
      open_register: "Abrir Caixa",
      close_register: "Fechar Caixa",
      opening_amount: "Valor de Abertura (R$)",
      closing_amount: "Valor em Caixa (R$)",
      observations: "Observações",
      observations_open: "Observações sobre a abertura...",
      observations_close: "Observações sobre o fechamento...",
      opening: "Abertura",
      inflows: "Entradas",
      outflows: "Saídas",
      expected_balance: "Saldo Esperado",
      opened_at: "Aberto em",
      difference: "Diferença",
      new_movement: "Nova Movimentação",
      sangria: "Sangria",
      suprimento: "Suprimento",
      amount: "Valor (R$)",
      movement_description: "Descrição",
      movement_placeholder: "Motivo da movimentação...",
      register_sangria: "Registrar Sangria",
      register_suprimento: "Registrar Suprimento",
      daily_movements: "Movimentações do Dia",
      no_movements: "Nenhuma movimentação registrada",
      sale: "Venda",
      refund: "Estorno",
      open_to_register: "Abra o caixa para registrar movimentações",
      date_from: "De",
      date_to: "Até",
      clear: "Limpar",
      no_history: "Nenhum registro de caixa encontrado",
      no_history_period: "Nenhum registro encontrado no período",
      open: "Aberto",
      closed: "Fechado",
      closing: "Fechamento",
      register_opened: "Caixa aberto com sucesso!",
      register_closed: "Caixa fechado com sucesso!",
      movement_registered: "registrado!",
      error_open: "Erro ao abrir caixa",
      error_close: "Erro ao fechar caixa",
      error_movement: "Erro ao registrar movimentação",
      details: "Detalhes do Caixa",
      copy: "Copiar",
      whatsapp: "WhatsApp",
      expected_value: "Valor Esperado",
      counted_value: "Valor Contado",
      balanced: "✓ Caixa bateu!",
      number_not_configured: "Número não configurado",
      configure_whatsapp: "Configure o número do WhatsApp nas configurações do negócio",
      report_sent: "Relatório enviado via WhatsApp!",
      send_error: "Erro ao enviar",
      send_error_desc: "Não foi possível enviar o relatório via WhatsApp",
      report_copied: "Relatório copiado!",
      products_sold: "Produtos Vendidos",
      financial_summary: "Resumo Financeiro",
      sales_by_payment: "Vendas por Forma de Pagamento",
      totals: "Totais",
      gross_revenue: "Receita Bruta",
      product_cost: "Custo dos Produtos",
      gross_profit: "Lucro Bruto",
      sales_suprim: "Vendas + Suprimentos",
      sangria_refund: "Sangrias + Estornos",
      no_movement: "Nenhuma movimentação",
    },

    // Wristbands
    wristbands: {
      title: "Pulseiras",
      active_wristbands: "Pulseiras Ativas",
      new: "Nova",
      no_active: "Nenhuma pulseira ativa",
      wristband: "Pulseira",
      cancel: "Cancelar",
      close: "Fechar",
      search_product_service: "Buscar produto ou serviço...",
      consumption: "Consumo",
      no_items: "Nenhum item adicionado",
      select_wristband: "Selecione uma pulseira",
      select_wristband_desc: "Clique em uma pulseira ativa ou crie uma nova",
      new_wristband: "Nova Pulseira",
      wristband_code: "Código da Pulseira *",
      code_placeholder: "Ex: A001, 123, etc",
      customer: "Cliente",
      search_customer: "Buscar por nome, telefone ou CPF...",
      no_customer_found: "Nenhum cliente encontrado",
      register_new: "Cadastrar Novo",
      create_wristband: "Criar Pulseira",
      quick_customer: "Cadastro Rápido de Cliente",
      name_required: "Nome *",
      customer_name: "Nome do cliente",
      phone: "Telefone",
      cpf: "CPF",
      birth_date: "Data de Nascimento",
      register_select: "Cadastrar e Selecionar",
      close_wristband: "Fechar Pulseira",
      subtotal: "Subtotal",
      discount: "Desconto (R$)",
      payment_method: "Forma de Pagamento",
      cash: "Dinheiro",
      credit: "Cartão Crédito",
      debit: "Cartão Débito",
      pix: "PIX",
      no_register_warning: "⚠️ Nenhum caixa aberto. O pagamento será registrado, mas não entrará no controle de caixa.",
      confirm_payment: "Confirmar Pagamento",
      wristband_created: "Pulseira criada!",
      wristband_closed: "Pulseira fechada com sucesso!",
      wristband_cancelled: "Pulseira cancelada",
      item_added: "adicionado!",
      error_create: "Erro ao criar pulseira",
      error_add_item: "Erro ao adicionar item",
      error_close: "Erro ao fechar pulseira",
      error_cancel: "Erro ao cancelar",
      customer_registered: "Cliente cadastrado!",
      error_customer: "Erro ao cadastrar cliente",
      enter_name: "Digite o nome do cliente",
      enter_code: "Digite o código da pulseira",
      discount_exceed: "Desconto não pode ser maior que o total",
    },

    // Chat
    chat: {
      emojis: "Emojis",
      image: "Imagem",
      document: "Documento",
      video: "Vídeo",
      quick_replies_click: "Respostas Rápidas (clique para enviar)",
      recording: "Gravando",
      type_message: "Digite sua mensagem...",
      microphone_error: "Não foi possível acessar o microfone",
      contact_details: "Detalhes do Contato",
      whatsapp_contact: "Contato WhatsApp",
      registered_customer: "Cliente cadastrado",
      contact_only: "Apenas contato",
      visits: "Visitas",
      total_spent: "Total gasto",
      view_full_details: "Ver Detalhes Completos",
      create_lead: "Criar Lead / Cliente",
      name_required: "Nome é obrigatório",
      customer_name: "Nome do cliente",
      lead_notes: "Notas sobre o lead...",
      create_lead_button: "Criar Lead",
      conversation_tags: "Tags de Conversas",
      tags_description: "Crie tags personalizadas para organizar suas conversas",
      new_tag: "Nova Tag",
      edit_tag: "Editar Tag",
      tag_name: "Nome da Tag",
      tag_placeholder: "Ex: Urgente, VIP, Novo Cliente...",
      tag_name_required: "Nome da tag é obrigatório",
      no_tags: "Nenhuma tag criada",
      create_tags_organize: "Crie tags para organizar suas conversas",
      confirm_delete_tag: "Tem certeza que deseja excluir esta tag?",
    },

    // Medical Records
    medical_records: {
      title: "Prontuário Eletrônico",
      subtitle: "Anamnese, evolução clínica e histórico de pacientes",
      patients: "Pacientes",
      records: "Prontuários",
      evolutions: "Evoluções",
      photos: "Fotos",
      search_patient: "Buscar paciente...",
      no_patient_found: "Nenhum paciente encontrado",
      no_patients: "Nenhum paciente encontrado",
      no_contact: "Sem contato",
      record: "Prontuário",
      select_patient_to_view: "Selecione um paciente para ver o prontuário",
      medications_in_use: "Medicamentos em Uso",
      select_patient_first: "Selecione um paciente primeiro.",
      fill_chief_complaint: "Preencha a queixa principal.",
      fill_evolution_content: "Preencha o conteúdo da evolução.",
      select_photo: "Selecione uma foto.",
      new_anamnesis: "Nova Anamnese",
      anamnesis: "Anamnese",
      chief_complaint: "Queixa Principal",
      chief_complaint_placeholder: "Descreva a queixa principal do paciente...",
      medical_history: "Histórico Médico",
      medical_history_placeholder: "Doenças prévias, cirurgias, internações...",
      allergies: "Alergias",
      allergies_placeholder: "Medicamentos, alimentos, outros...",
      medications: "Medicamentos em Uso",
      medications_placeholder: "Liste os medicamentos...",
      family_history: "Histórico Familiar",
      family_history_placeholder: "Doenças na família...",
      lifestyle: "Estilo de Vida",
      lifestyle_placeholder: "Hábitos, atividades físicas...",
      save_anamnesis: "Salvar Anamnese",
      ai_suggestion: "Sugestão IA",
      new_evolution: "Nova Evolução",
      clinical_evolution: "Evolução Clínica",
      evolution: "Evolução",
      evolution_placeholder: "Descreva a evolução do paciente...",
      diagnosis: "Diagnóstico",
      diagnosis_placeholder: "Diagnóstico ou hipótese diagnóstica...",
      treatment: "Tratamento",
      treatment_placeholder: "Plano de tratamento...",
      observations: "Observações",
      observations_placeholder: "Observações adicionais...",
      save_evolution: "Salvar Evolução",
      add_photo: "Adicionar Foto",
      upload_photo: "Upload de Foto",
      select_file: "Selecione um arquivo",
      photo_description: "Descrição",
      photo_description_placeholder: "Descrição da foto...",
      photo_category: "Categoria",
      category_placeholder: "Ex: Antes, Depois, Exame...",
      upload: "Fazer Upload",
      select_patient_record: "Selecione um paciente para ver o prontuário",
      anamnesis_history: "Histórico de Anamneses",
      no_anamnesis: "Nenhuma anamnese registrada",
      evolutions_history: "Evoluções Clínicas",
      no_evolutions: "Nenhuma evolução registrada",
      photo_gallery: "Galeria de Fotos",
      no_photos: "Nenhuma foto registrada",
      delete_photo: "Excluir Foto",
      delete_photo_confirm: "Tem certeza que deseja excluir esta foto?",
      ai_suggestion_title: "Sugestão da IA",
      ai_error: "Erro ao processar sugestão com IA.",
    },

    // Contracts
    contracts: {
      title: "Contratos",
      new_template: "Novo Template",
      new_contract: "Novo Contrato",
      create_template: "Criar Template de Contrato",
      template_name: "Nome do template",
      template_content: "Conteúdo do contrato. Use {{nome_cliente}}, {{email_cliente}}, {{data_atual}} como placeholders.",
      create_template_btn: "Criar Template",
      generate_contract: "Gerar Contrato",
      edit_contract: "Editar Contrato",
      select_client: "Selecione o cliente",
      search_client: "Buscar cliente...",
      no_client_found: "Nenhum cliente encontrado.",
      select_template: "Selecione um template (opcional)",
      search_template: "Buscar template...",
      no_template_found: "Nenhum template encontrado.",
      contract_content: "Conteúdo do contrato",
      save_changes: "Salvar Alterações",
      create_contract_btn: "Criar Contrato",
      total: "Total",
      drafts: "Rascunhos",
      sent: "Enviados",
      signed: "Assinados",
      contracts_tab: "Contratos",
      templates_tab: "Templates",
      search_by_client: "Buscar por cliente...",
      all_status: "Todos os status",
      draft: "Rascunho",
      cancelled: "Cancelado",
      loading: "Carregando...",
      no_contracts: "Nenhum contrato encontrado",
      no_contract_found: "Nenhum contrato encontrado",
      created_at: "Criado em",
      signed_at: "Assinado em",
      copy_link: "Copiar Link",
      open_link: "Abrir Link",
      no_templates: "Nenhum template criado",
      no_template_found_msg: "Nenhum template encontrado",
      contract_details: "Detalhes do Contrato",
      close: "Fechar",
      print: "Imprimir",
      share: "Compartilhar",
      send_signature: "Enviar para Assinatura",
      signature_pending: "Assinatura Pendente",
      delete_contract: "Excluir Contrato",
      delete_contract_confirm: "Tem certeza que deseja excluir este contrato? Esta ação não pode ser desfeita.",
      delete_template: "Excluir Template",
      delete_template_confirm: "Tem certeza que deseja excluir este template? Esta ação não pode ser desfeita.",
      link_copied: "Link copiado!",
      client: "Cliente",
      signer_ip: "IP do Signatário",
      share_contract: "Compartilhar Contrato",
      status: {
        draft: "Rascunho",
        sent: "Enviado",
        signed: "Assinado",
        cancelled: "Cancelado",
      },
    },

    // Training
    training: {
      title: "Treinamentos",
      subtitle: "Capacitação e desenvolvimento da equipe",
      new_course: "Novo Curso",
      create_course: "Criar Novo Curso",
      course_title: "Título",
      course_name: "Nome do curso",
      course_description: "Descrição",
      course_description_placeholder: "Descrição do curso",
      create_course_btn: "Criar Curso",
      courses: "Cursos",
      in_progress: "Em andamento",
      completed: "Concluídos",
      pending: "Pendentes",
      search_course: "Buscar curso...",
      all: "Todos",
      enrolled: "Matriculado",
      not_enrolled: "Não matriculado",
      loading: "Carregando...",
      no_courses: "Nenhum curso criado",
      no_courses_found: "Nenhum curso encontrado",
      no_description: "Sem descrição",
      select_course: "Selecione um curso",
      select_course_desc: "Selecione um curso para ver e editar o conteúdo",
      module: "Módulo",
      add_module: "Adicionar Módulo",
      module_title: "Título do Módulo",
      module_title_placeholder: "Ex: Introdução",
      module_description: "Descrição",
      module_description_placeholder: "Descrição do módulo",
      create_module_btn: "Criar Módulo",
      no_modules: "Nenhum módulo criado",
      add_module_tip: "Clique em \"Módulo\" para adicionar conteúdo",
      add_lesson: "Adicionar Aula",
      lesson_title: "Título da Aula",
      lesson_title_placeholder: "Ex: Boas-vindas",
      lesson_content: "Conteúdo",
      lesson_content_placeholder: "Conteúdo da aula...",
      video_url: "URL do Vídeo (opcional)",
      duration: "Duração (min)",
      create_lesson_btn: "Criar Aula",
      no_lessons: "Adicione aulas ao módulo",
      enroll: "Matricular-se",
      enrollment: "Matrícula",
      status: {
        completed: "Concluído",
        in_progress: "Em andamento",
        not_started: "Não iniciado",
      },
      module_created: "Módulo criado!",
      lesson_created: "Aula criada!",
      module_deleted: "Módulo excluído!",
      lesson_deleted: "Aula excluída!",
    },

    // Forms
    forms: {
      title: "Formulários",
      subtitle: "Crie formulários personalizados para coleta de dados",
      new_form: "Novo Formulário",
      create_form: "Criar Formulário",
      form_config: "Configure as opções do novo formulário",
      form_name: "Nome",
      form_name_placeholder: "Ex: Ficha de Anamnese",
      form_description: "Descrição",
      form_description_placeholder: "Descrição do formulário",
      form_type: "Tipo",
      type_generic: "Genérico",
      type_pre_attendance: "Pré-Atendimento",
      type_survey: "Pesquisa",
      expiration_date: "Data de Expiração (opcional)",
      allow_image: "Permitir upload de imagem",
      capture_location: "Capturar localização",
      creating: "Criando...",
      create_btn: "Criar",
      forms: "Formulários",
      forms_count: "Formulários",
      active: "Ativos",
      responses: "Respostas",
      your_forms: "Seus Formulários",
      search: "Buscar...",
      type: "Tipo",
      all_types: "Todos tipos",
      all: "Todos",
      all_status: "Todos",
      generic: "Genérico",
      pre_attendance: "Pré-Atendimento",
      survey: "Pesquisa",
      active_only: "Ativos",
      inactive: "Inativos",
      inactive_only: "Inativos",
      loading: "Carregando...",
      no_forms: "Nenhum formulário criado",
      no_forms_found: "Nenhum formulário encontrado",
      no_description: "Sem descrição",
      expires: "Expira",
      fields: "Campos",
      responses_tab: "Respostas",
      add_field: "Adicionar Campo",
      field_label: "Nome do campo",
      field_label_placeholder: "Nome do campo",
      field_type: "Tipo",
      type_text: "Texto",
      type_number: "Número",
      type_boolean: "Sim/Não",
      type_select: "Seleção",
      add_btn: "Adicionar",
      no_fields: "Nenhum campo adicionado",
      settings: "Configurações",
      copy_link: "Copiar Link",
      open_link: "Abrir Link",
      toggle_status: "Ativar/Desativar",
      delete_form: "Excluir",
      select_form: "Selecione um formulário",
      select_form_desc: "Selecione um formulário à esquerda para visualizar ou editar",
      options_modal: "Opções do Campo",
      options_modal_desc: "Adicione as opções para este campo de seleção",
      option_placeholder: "Nova opção",
      add_option: "Adicionar",
      confirm_options: "Confirmar Opções",
      add_at_least_one: "Adicione pelo menos uma opção",
      form_settings: "Configurações do Formulário",
      form_settings_desc: "Ajuste as configurações avançadas do formulário",
      save_settings: "Salvar Configurações",
      link_copied: "Link copiado!",
    },

    // Team
    team: {
      title: "Equipe",
      description: "Gerencie membros com acesso e profissionais da agenda",
      with_access: "Com Acesso",
      pending: "Pendentes",
      agenda_only: "Só Agenda",
      invite_member: "Convidar Membro",
      no_members: "Nenhum membro na equipe",
      invite_desc: "Convide membros para dar acesso ao sistema",
      linked_agenda: "Vinculado à agenda",
      make_admin: "Tornar Admin",
      make_staff: "Tornar Colaborador",
      remove: "Remover",
      no_pending: "Nenhum convite pendente",
      expires_at: "Expira em",
      professionals_desc: "Profissionais que aparecem na agenda mas não têm acesso ao sistema. Para dar acesso, convide-os na aba \"Com Acesso\".",
      new_professional: "Novo Profissional",
      edit_professional: "Editar Profissional",
      full_name: "Nome completo",
      registration: "Matrícula",
      employee_code: "Código do funcionário",
      role: "Função",
      role_placeholder: "Ex: Cabeleireiro, Manicure",
      commission: "Comissão (%)",
      professional_active: "Profissional ativo",
      create_professional: "Criar Profissional",
      no_professionals: "Nenhum profissional cadastrado",
      register_desc: "Cadastre profissionais para usar na agenda",
      no_role: "Sem função",
      commission_suffix: "comissão",
      invite_new: "Convidar Novo Membro",
      permission: "Permissão",
      staff_default: "Colaborador (padrão)",
      admin: "Administrador",
      permission_desc: "Colaboradores têm acesso limitado. Admins têm acesso total.",
      send_invite: "Enviar Convite",
      remove_member: "Remover membro",
      remove_confirm: "Tem certeza que deseja remover este membro da equipe? Ele perderá acesso ao sistema.",
      remove_btn: "Remover",
      owner: "Proprietário",
      updated: "Profissional atualizado!",
      created: "Profissional criado!",
      error_update: "Erro ao atualizar profissional",
      name_required: "Nome é obrigatório",
      inactive: "Inativo",
    },

    // API Keys
    api_keys: {
      title: "Chaves de API",
      description: "Gerencie suas chaves de API para integração",
      new_key: "Nova Chave",
      create_key: "Criar Chave",
      key_name: "Nome da Chave",
      key_name_placeholder: "Ex: Integração ERP",
      key_created: "Chave criada com sucesso!",
      key_deleted: "Chave excluída com sucesso",
      copy_key: "Copiar Chave",
      key_copied: "Chave copiada!",
      show_key: "Mostrar Chave",
      hide_key: "Ocultar Chave",
      last_used: "Último uso",
      never_used: "Nunca usada",
      delete_confirm: "Tem certeza que deseja excluir esta chave?",
      delete_warning: "Esta ação não pode ser desfeita. Integrações usando esta chave deixarão de funcionar.",
      active: "Ativa",
      inactive: "Inativa",
      error_create: "Erro ao criar chave",
      error_delete: "Erro ao excluir chave",
      name_required: "Digite um nome para a chave",
      business_not_found: "Negócio não encontrado",
      keys_tab: "Minhas Chaves",
      docs_tab: "Documentação",
      playground_tab: "Playground",
      no_keys: "Nenhuma chave de API criada",
      create_first: "Crie sua primeira chave para começar a integrar",
      warning_copy: "Copie sua chave agora. Ela não será exibida novamente!",
      endpoints: "Endpoints",
      test: "Testar",
      testing: "Testando...",
      select_key: "Selecione uma chave",
      authentication: "Autenticação",
      auth_description: "Use sua chave de API no header Authorization:",
      prefix: "Prefixo",
      copy_code: "Copiar código",
      params: "Parâmetros",
      body_example: "Body (exemplo)",
      playground_description: "Teste os endpoints da API diretamente no navegador",
      create_to_test: "Crie uma chave de API para testar os endpoints",
    },

    // Chatbot Knowledge
    chatbot_knowledge: {
      title: "Base de Conhecimento",
      description: "Treine o chatbot com documentos e perguntas frequentes",
      documents_tab: "Documentos",
      qa_tab: "Perguntas e Respostas",
      add_document: "Adicionar Documento",
      document_name: "Nome do Documento",
      document_name_placeholder: "Ex: Política de cancelamento",
      document_content: "Conteúdo",
      document_content_placeholder: "Cole aqui o conteúdo do documento que o chatbot deve conhecer...",
      saving: "Salvando...",
      save_document: "Salvar Documento",
      no_documents: "Nenhum documento adicionado",
      no_documents_desc: "Adicione documentos como políticas, regras, informações sobre serviços, etc.",
      added_at: "Adicionado em",
      add_question: "Adicionar Pergunta",
      add_qa: "Adicionar Pergunta e Resposta",
      question: "Pergunta",
      question_placeholder: "Ex: Qual o horário de funcionamento?",
      answer: "Resposta",
      answer_placeholder: "Ex: Funcionamos de segunda a sexta, das 8h às 18h.",
      save: "Salvar",
      no_questions: "Nenhuma pergunta adicionada",
      no_questions_desc: "Adicione perguntas frequentes e suas respostas para o chatbot responder rapidamente",
      documents_helper: "Adicione documentos para o chatbot consultar durante as conversas",
      qa_helper: "Adicione perguntas frequentes para respostas rápidas e precisas",
    },

    // Staff
    staff: {
      title: "Profissionais",
      description: "Gerencie os profissionais que prestam serviços",
      new_professional: "Novo Profissional",
      edit_professional: "Editar Profissional",
      name: "Nome",
      name_required: "Nome é obrigatório",
      full_name: "Nome completo",
      email: "E-mail",
      phone: "Telefone",
      registration: "Matrícula",
      employee_code: "Código do funcionário",
      cpf: "CPF",
      role: "Função",
      role_placeholder: "Ex: Cabeleireiro, Manicure",
      commission: "Comissão (%)",
      professional_active: "Profissional ativo",
      save: "Salvar",
      create: "Criar Profissional",
      updated: "Profissional atualizado!",
      created: "Profissional criado!",
      error_update: "Erro ao atualizar profissional",
      no_professionals: "Nenhum profissional cadastrado",
      no_role: "Sem função",
      commission_suffix: "comissão",
      inactive: "Inativo",
    },

    // Linktree / Bio Page
    linktree: {
      title: "Bio Page",
      description: "Sua página de links profissional",
      create_page: "Criar sua Bio Page",
      slug_not_configured: "Slug não configurado",
      slug_config_hint: "Configure um slug em Configurações → Dados do Negócio para criar sua Bio Page.",
      page_url: "URL da sua página",
      display_name: "Nome de exibição",
      display_name_placeholder: "Ex: Minha Empresa",
      create_bio: "Criar Bio Page",
      copy: "Copiar",
      view_site: "Ver Site",
      link_copied: "Link copiado!",
      views: "Views",
      clicks: "Cliques",
      links: "Links",
      my_links: "Meus Links",
      new_link: "Novo Link",
      add_link: "Adicionar Link",
      link_type: "Tipo de Link",
      link_title: "Título",
      link_url: "URL",
      link_description: "Descrição",
      link_icon: "Ícone/Emoji",
      button_style: "Estilo do Botão",
      save_link: "Salvar Link",
      edit_link: "Editar Link",
      no_links: "Nenhum link adicionado",
      add_first: "Adicione seu primeiro link",
      delete_link: "Excluir link",
      design_tab: "Design",
      links_tab: "Links",
      integrations_tab: "Integr.",
      social_tab: "Social",
      bio: "Bio",
      theme_color: "Cor do Tema",
      background_color: "Cor de Fundo",
      text_color: "Cor do Texto",
      button_type: "Estilo dos Botões",
      font_family: "Fonte",
      profile_image: "Foto de Perfil",
      banner_image: "Banner",
      show_booking: "Mostrar botão de agendamento",
      show_catalog: "Mostrar botão do catálogo",
      show_coupons: "Mostrar cupons",
      show_products: "Mostrar produtos",
      show_social: "Mostrar ícones de redes sociais",
      show_categories: "Mostrar categorias",
      save_settings: "Salvar Configurações",
      settings_saved: "Configurações salvas!",
      loading: "Carregando...",
      link_types: {
        link: "Link Externo",
        product: "Produto",
        video: "Vídeo",
        image: "Imagem",
        whatsapp_group: "Grupo WhatsApp",
      },
      button_styles: {
        filled: "Preenchido",
        outline: "Contorno",
        soft: "Suave",
        glass: "Vidro",
      },
      // Form labels
      title_required: "Título *",
      title_placeholder: "Ex: Nosso Instagram",
      url_label: "URL",
      url_placeholder: "https://",
      product_label: "Produto do Catálogo",
      select_product: "Selecione um produto",
      video_url_label: "URL do Vídeo (YouTube/Vimeo)",
      video_url_placeholder: "https://youtube.com/...",
      groups_available: "{{count}} grupo(s) disponível(eis)",
      no_groups_configured: "Nenhum grupo configurado",
      groups_rotate_hint: "O link será rotacionado automaticamente para grupos com vagas",
      configure_groups_hint: "Configure grupos em Grupos WhatsApp primeiro",
      description_optional: "Descrição (opcional)",
      description_placeholder: "Breve descrição do link",
      thumbnail: "Thumbnail",
      thumbnail_placeholder: "Imagem do link",
      category_label: "Categoria",
      category_placeholder: "Ex: Redes Sociais",
      icon_label: "Ícone (emoji)",
      add_link_btn: "Adicionar Link",
      no_links_yet: "Nenhum link adicionado ainda",
      click_to_start: "Clique em \"Novo Link\" para começar",
      no_url: "Sem URL",
      active: "Ativo",
      inactive: "Inativo",
      // Design tab
      appearance: "Aparência",
      display_name_label: "Nome de Exibição",
      display_name_design_placeholder: "Nome da sua página",
      font_label: "Fonte",
      bio_label: "Bio / Descrição",
      bio_placeholder: "Uma breve descrição sobre você ou sua empresa",
      main_color: "Cor Principal",
      background: "Fundo",
      text: "Texto",
      button_style_label: "Estilo Botões",
      profile_photo: "Foto de Perfil",
      banner: "Banner",
      save_design: "Salvar Design",
      // Integrations tab
      catalog_integrations: "Integrações com Catálogo",
      catalog_settings: "Configurações do catálogo na Bio Page",
      products_count: "Produtos em destaque",
      // Social tab
      social_networks: "Redes Sociais",
      social_desc: "Adicione links para suas redes sociais",
      instagram: "Instagram",
      facebook: "Facebook",
      whatsapp: "WhatsApp",
      tiktok: "TikTok",
      youtube: "YouTube",
      save_social: "Salvar Redes Sociais",
      // Edit link dialog
      edit_link_title: "Editar Link",
      save_changes: "Salvar Alterações",
      // Integrations
      catalog_button: "Botão Catálogo",
      catalog_button_desc: "Exibir botão de acesso ao catálogo",
      featured_products: "Produtos em Destaque",
      featured_products_desc: "Mostrar produtos do catálogo",
      featured_products_count: "Quantidade de produtos em destaque",
      products_count_label: "{{count}} produtos",
      booking_button: "Botão Agendar",
      booking_button_desc: "Link para agendamento online",
      active_coupons: "Cupons Ativos",
      active_coupons_desc: "Mostrar cupons de desconto",
      show_categories_label: "Mostrar Categorias",
      show_categories_desc: "Organizar links por categoria",
      save_integrations: "Salvar Integrações",
      // Social
      show_social_icons: "Exibir ícones de redes sociais",
      show_social_icons_desc: "Mostrar ícones clicáveis no perfil",
    },

    // Real Estate Module
    real_estate: {
      title: "Imobiliária",
      subtitle: "Gestão completa de imóveis, contratos e pagamentos",
      description: "Gestão de imóveis e aluguéis",
      properties: "Imóveis",
      inspections: "Vistorias",
      templates: "Modelos",
      new_property: "Novo Imóvel",
      register_property: "Cadastrar Imóvel",
      search_placeholder: "Buscar imóveis...",
      search_property: "Buscar imóvel...",
      filter_status: "Filtrar Status",
      all_status: "Todos",
      show_inactive: "Mostrar inativos",
      no_property_found: "Nenhum imóvel encontrado",
      no_client_found: "Nenhum cliente encontrado",
      add_photos: "Adicionar Fotos",
      // Property types
      property_types: {
        apartment: "Apartamento",
        house: "Casa",
        commercial: "Comercial",
        land: "Terreno",
      },
      // Status
      status: {
        available: "Disponível",
        rented: "Alugado",
        sold: "Vendido",
        maintenance: "Manutenção",
        inactive: "Inativos",
      },
      // Stats
      stats: {
        total: "Total",
        available: "Disponíveis",
        rented: "Alugados",
        monthly_income: "Receita/mês",
        pending: "Pendentes",
      },
      total_properties: "Imóveis",
      rented_count: "Alugados",
      available_count: "Disponíveis",
      maintenance_count: "Manutenção",
      // Tabs
      tabs: {
        properties: "Imóveis",
        templates: "Templates",
        inspections: "Vistorias",
        owners: "Proprietários",
        tenants: "Inquilinos",
        payments: "Pagamentos",
        maintenance: "Manutenção",
      },
      // Fields
      fields: {
        title: "Título",
        address: "Endereço",
        type: "Tipo",
        bedrooms: "Quartos",
        bathrooms: "Banheiros",
        parking: "Vagas",
        area: "Área (m²)",
        rent_value: "Valor Aluguel",
        sale_value: "Valor Venda",
        description: "Descrição",
        owner: "Proprietário",
        photo_gallery: "Galeria de Fotos",
      },
      // Placeholders
      placeholders: {
        title: "Ex: Apartamento Centro",
        address: "Rua, número, bairro",
        description: "Descrição do imóvel...",
        select_owner: "Selecione o proprietário...",
        search_client: "Buscar cliente...",
        select_tenant: "Selecione o inquilino...",
        room_name: "Nome do cômodo",
        add_item: "Adicionar item...",
        select_property: "Selecione o imóvel...",
        search_property: "Buscar imóvel...",
      },
      // Form
      title_label: "Título",
      address: "Endereço",
      type: "Tipo",
      bedrooms: "Quartos",
      bathrooms: "Banheiros",
      parking: "Vagas",
      area: "Área (m²)",
      rent_value: "Valor Aluguel",
      sale_value: "Valor Venda",
      description_label: "Descrição",
      owner: "Proprietário",
      select_owner: "Selecione o proprietário",
      no_owner: "Sem proprietário",
      images: "Imagens",
      upload_images: "Clique para enviar imagens",
      required_fields: "Preencha os campos obrigatórios.",
      create_property: "Criar Imóvel",
      edit_property: "Editar Imóvel",
      save_changes: "Salvar Alterações",
      deactivate: "Desativar",
      activate: "Ativar",
      delete: "Excluir",
      loading: "Carregando...",
      no_properties: "Nenhum imóvel encontrado",
      add_first: "Adicione seu primeiro imóvel",
      view_details: "Ver Detalhes",
      // Payment types
      payment_types: {
        rent: "Aluguel",
        deposit: "Caução",
        condominium: "Condomínio",
        water: "Água",
        electricity: "Energia",
        iptu: "IPTU",
        other: "Outro",
      },
      // Inspections
      inspection: "Vistoria",
      new_inspection: "Nova Vistoria",
      inspection_type: "Tipo de Vistoria",
      entry: "Entrada",
      exit: "Saída",
      inspection_notes: "Observações da Vistoria",
      rooms_items: "Cômodos e Itens",
      add_room: "Adicionar Cômodo",
      add_item: "Adicionar Item",
      item_condition: "Condição",
      conditions: {
        excellent: "Excelente",
        good: "Bom",
        regular: "Regular",
        bad: "Ruim",
      },
      take_photo: "Tirar Foto",
      save_inspection: "Salvar Vistoria",
      no_inspection: "Nenhuma vistoria registrada",
      items_verified: "itens verificados",
      // Templates
      new_template: "Novo Template",
      template_name: "Nome do Template",
      property_type: "Tipo de Imóvel",
      room_name: "Nome do Cômodo",
      create_template: "Criar Template",
      edit_template: "Editar Template",
      delete_template: "Excluir Template",
      load_default_template: "Carregar Template Padrão",
      rooms: "Cômodos",
      default_templates: "Templates Padrão do Sistema",
      my_templates: "Meus Templates",
      no_custom_templates: "Nenhum template personalizado",
      create_templates_hint: "Crie templates para agilizar suas vistorias",
      rooms_count: "cômodos",
      items_count: "itens",
      // Contracts
      contract: "Contrato",
      new_contract: "Novo Contrato",
      tenant: "Inquilino",
      select_tenant: "Selecione o inquilino",
      start_date: "Data Início",
      end_date: "Data Fim",
      deposit: "Caução",
      payment_day: "Dia de Pagamento",
      create_contract: "Criar Contrato",
      // Payments
      payment: "Pagamento",
      new_payment: "Lançar Pagamento",
      amount: "Valor",
      due_date: "Vencimento",
      payment_notes: "Observações",
      create_payment: "Lançar",
      no_payment: "Nenhum pagamento registrado",
      pay: "Pagar",
      paid: "Pago",
      // Maintenance
      maintenance_title: "Manutenção",
      new_maintenance: "Registrar Manutenção",
      category: "Categoria",
      priority: "Prioridade",
      estimated_cost: "Custo Estimado",
      scheduled_date: "Data Agendada",
      create_maintenance: "Registrar",
      no_maintenance: "Nenhuma manutenção registrada",
      complete: "Concluir",
      maintenance_status: {
        pending: "Pendente",
        in_progress: "Em andamento",
        completed: "Concluída",
      },
      priorities: {
        low: "Baixa",
        medium: "Média",
        high: "Alta",
        urgent: "Urgente",
      },
      categories: {
        general: "Geral",
        electrical: "Elétrica",
        plumbing: "Hidráulica",
        painting: "Pintura",
        cleaning: "Limpeza",
        other: "Outro",
      },
      // Property details
      contracts_tab: "Contratos",
      payments_tab: "Pagamentos",
      maintenance_tab: "Manutenções",
      gallery: "Galeria",
      no_images: "Sem imagens",
      confirm_delete: "Confirmar exclusão",
      delete_property_confirm: "Tem certeza que deseja excluir este imóvel?",
      // Owners and Tenants
      no_owners: "Nenhum proprietário cadastrado",
      owners_hint: "Proprietários são clientes vinculados a imóveis",
      no_tenants: "Nenhum inquilino cadastrado",
      tenants_hint: "Inquilinos são clientes com contrato ativo",
      properties_count: "imóveis",
    },

    // Quick Create Menu
    quick_create: {
      create: "Criar",
      new_customer: "Novo Cliente",
      new_sale: "Nova Venda",
      new_appointment: "Novo Agendamento",
      new_task: "Nova Tarefa",
      new_proposal: "Nova Proposta",
    },

    // Goals
    goals: {
      title: "Metas e KPIs",
      description: "Defina e acompanhe suas metas de negócio",
      new_goal: "Nova Meta",
      create_goal: "Criar Meta",
      goal_name: "Nome da meta",
      goal_name_placeholder: "Ex: Faturamento de Janeiro",
      type: "Tipo",
      target_value: "Valor alvo",
      start: "Início",
      end: "Fim",
      search_goals: "Buscar metas...",
      filter_type: "Filtrar tipo",
      all_types: "Todos os tipos",
      active_goals: "Metas Ativas",
      history: "Histórico de Metas",
      progress: "Progresso",
      current: "Atual",
      target: "Meta",
      no_goals_found: "Nenhuma meta encontrada",
      try_filters: "Tente alterar os filtros",
      start_creating: "Comece definindo suas primeiras metas",
      completed: "Concluída",
      not_achieved: "Não atingida",
      types: {
        revenue: "Faturamento",
        sales_count: "Qtd. Vendas",
        new_customers: "Novos Clientes",
        appointments: "Agendamentos",
        products_sold: "Produtos Vendidos",
        services_sold: "Serviços Vendidos",
      },
    },

    // Lead Funnel Analytics
    lead_funnel: {
      analytics_title: "Analytics do Funil IA",
      analytics_description: "Métricas e performance do funil de qualificação",
      total_leads: "Total de Leads",
      hot_leads: "Leads Quentes",
      conversion_rate: "Taxa Conversão",
      scheduling_rate: "Taxa Agendamento",
      avg_score: "Score Médio dos Leads",
      hot: "Quentes",
      warm: "Mornos",
      cold: "Frios",
      funnel_by_stage: "Funil por Etapa",
      classification: "Classificação dos Leads",
      recent_leads: "Leads Recentes",
      no_name: "Sem nome",
      no_leads_yet: "Nenhum lead capturado ainda.",
      stages: {
        new: "Novos",
        qualifying: "Qualificando",
        qualified: "Qualificados",
        scheduled: "Agendados",
        converted: "Convertidos",
        lost: "Perdido",
      },
      sources: {
        manual: "Manual",
        form: "Formulário",
        crm_customer: "Cliente CRM",
        import: "Importação",
      },
    },

    // Checklist
    checklist: {
      title: "Checklists",
      description: "Gerencie rotinas e inspeções",
      new_checklist: "Novo Checklist",
      create_checklist: "Criar Checklist",
      name_placeholder: "Ex: Checklist de Abertura",
      description_optional: "Descrição (opcional)",
      describe_checklist: "Descreva o checklist...",
      checklist_items: "Itens do Checklist",
      item_description: "Descrição do item",
      templates: "Modelos",
      history: "Histórico",
      search_checklist: "Buscar checklist...",
      all_types: "Todos os tipos",
      no_checklists_created: "Nenhum checklist criado",
      no_checklists_found: "Nenhum checklist encontrado",
      create_first: "Crie seu primeiro checklist para começar",
      try_filters: "Tente ajustar os filtros",
      items: "itens",
      execute: "Executar",
      no_executions: "Nenhuma execução registrada",
      by: "por",
      complete: "Completo",
      partial: "Parcial",
      type_here: "Digite...",
      finish_checklist: "Finalizar Checklist",
      types: {
        opening: "Abertura",
        closing: "Fechamento",
        cleaning: "Limpeza",
        inspection: "Inspeção",
        epi: "EPI",
        general: "Geral",
      },
      field_types: {
        boolean: "Sim/Não",
        text: "Texto",
        number: "Número",
      },
    },

    // Gym
    gym: {
      title: "Academia",
      description: "Gestão de alunos, treinos e evolução física",
      students: "Alunos",
      plans: "Planos",
      workouts: "Treinos",
      workout: "Treino",
      evolution: "Evolução",
      nutrition: "Dieta",
      active_plans: "Planos Ativos",
      expiring: "Vencendo",
      search_student: "Buscar aluno...",
      no_students_found: "Nenhum aluno encontrado",
      no_phone: "Sem telefone",
      new_plan: "Novo Plano",
      create_plan: "Criar Plano",
      create_plan_for_student: "Criar Plano para Aluno",
      student: "Aluno",
      plan: "Plano",
      price: "Valor",
      duration_months: "Duração",
      start_date: "Data de Início",
      new_workout: "Novo Treino",
      create_workout: "Criar Treino",
      workout_title: "Título do Treino",
      workout_description: "Descrição",
      level: "Nível",
      exercises: "Exercícios",
      add_exercise: "Adicionar",
      no_workouts_found: "Nenhum treino encontrado",
      no_workouts_desc: "Crie treinos personalizados ou use modelos",
      fill_required_fields: "Preencha todos os campos obrigatórios.",
      fill_workout_title: "Preencha o título do treino.",
      select_student_first: "Selecione um aluno primeiro.",
      error_creating_workout: "Erro ao criar treino:",
      error_generating_suggestion: "Erro ao gerar sugestão de treino.",
      suggestion_generated: "Sugestão gerada.",
      levels: {
        beginner: "Iniciante",
        intermediate: "Intermediário",
        advanced: "Avançado",
      },
      plan_types: {
        monthly: "Mensal",
        quarterly: "Trimestral",
        semiannual: "Semestral",
        annual: "Anual",
      },
      ai_prompts: {
        beginner: "Crie um plano de treino para iniciante com 3 dias por semana, incluindo exercícios básicos com séries e repetições.",
        intermediate: "Crie um plano de treino intermediário com 4 dias por semana, focando em hipertrofia.",
        advanced: "Crie um plano de treino avançado com 5 dias por semana, técnicas avançadas de intensidade.",
      },
    },

    // Delivery
    delivery: {
      title: "Delivery Próprio",
      subtitle: "Gerencie entregas, zonas e entregadores",
      tabs: { orders: "Pedidos", zones: "Zonas", drivers: "Entregadores", settings: "Configurações" },
      stats: { total_orders: "Total de Pedidos", pending: "Pendentes", in_delivery: "Em Entrega", delivered: "Entregues", cancelled: "Cancelados" },
      drivers_today: "Entregas por Entregador (Hoje)",
      driver: "Entregador",
      orders_found: "{{count}} pedido(s) encontrado(s)",
      delivery_orders: "Pedidos de Delivery",
      no_orders: "Nenhum pedido encontrado",
      table: { code: "Código", customer: "Cliente", address: "Endereço", fee: "Taxa" },
      assign: "Atribuir",
      page_of: "Página {{current}} de {{total}}",
      previous: "Anterior",
      next: "Próximo",
      status: { pending: "Pendente", preparing: "Preparando", ready: "Pronto", out_for_delivery: "Saiu p/ Entrega", delivered: "Entregue", cancelled: "Cancelado", rejected: "Recusado" },
      vehicle: { moto: "Moto", bicycle: "Bicicleta", car: "Carro", on_foot: "A pé" },
      zones: { title: "Zonas de Entrega", new_zone: "Nova Zona", new_zone_title: "Nova Zona de Entrega", edit_zone: "Editar Zona", edit_zone_desc: "Altere os dados da zona de entrega", new_zone_desc: "Configure uma nova zona de entrega com taxas e tempo estimado", zone_name: "Nome da Zona", zone_name_placeholder: "Ex: Centro, Zona Sul", cep_range: "Faixa de CEP", neighborhood: "Bairro", cep_start: "CEP Início", cep_end: "CEP Fim", neighborhood_placeholder: "Nome do bairro", delivery_fee: "Taxa de Entrega (R$)", estimated_time: "Tempo Estimado (min)", zone_active: "Zona ativa", create_zone: "Criar Zona", no_zones: "Nenhuma zona cadastrada. Crie zonas para definir taxas de entrega por região.", region: "Região" },
      drivers: { title: "Entregadores", new_driver: "Novo Entregador", edit_driver: "Editar Entregador", edit_driver_desc: "Altere os dados do entregador", new_driver_desc: "Cadastre um novo entregador para sua equipe de delivery", name_placeholder: "Nome do entregador", vehicle: "Veículo", plate: "Placa", available: "Disponível", busy: "Ocupado", register: "Cadastrar", no_drivers: "Nenhum entregador cadastrado. Cadastre seus motoboys para atribuir entregas." },
      settings: { title: "Configurações de Delivery", delivery_enabled: "Delivery Ativado", delivery_enabled_desc: "Habilitar sistema de delivery", whatsapp_notifications: "Notificações WhatsApp", whatsapp_notifications_desc: "Enviar atualizações de status automaticamente", auto_assign: "Atribuição Automática", auto_assign_desc: "Atribuir entregadores automaticamente", default_time: "Tempo Padrão (min)", min_order: "Pedido Mínimo (R$)", max_radius: "Raio Máximo (km)" },
    },

    // Commissions
    commissions: {
      title: "Comissões",
      subtitle: "Gerencie regras e pagamentos de comissões",
      new_rule: "Nova Regra",
      active_rules: "Regras Ativas",
      pending: "Pendente",
      paid_period: "Pago (período)",
      total_period: "Total (período)",
      tabs: { summary: "Resumo por Profissional", entries: "Lançamentos", rules: "Regras" },
      start_date: "Data Início",
      end_date: "Data Fim",
      no_commissions_period: "Nenhuma comissão no período",
      entries_count: "{{count}} lançamentos",
      pending_label: "pendente",
      paid_label: "pago",
      search_professional: "Buscar por profissional...",
      professional: "Profissional",
      pay_selected: "Pagar Selecionados ({{count}})",
      no_entries: "Nenhum lançamento encontrado",
      paid: "Pago",
      no_rules: "Nenhuma regra cadastrada",
      all_professionals: "Todos profissionais",
      new_commission_rule: "Nova Regra de Comissão",
      service: "Serviço",
      all_services: "Todos os serviços",
      percentage: "Percentual (%)",
      fixed_value: "Valor Fixo (R$)",
      create_rule: "Criar Regra",
    },

    // Communication
    communication: {
      chat: "Chat",
      create_channel: "Criar Canal",
      channel_name: "Nome do canal",
      channel_name_placeholder: "Ex: #geral, #vendas",
      members_access: "Membros com acesso",
      members_access_desc: "Deixe vazio para todos da equipe terem acesso",
      member: "Membro",
      channels: "Canais",
      no_channels: "Nenhum canal",
      team: "Equipe",
      my_status: "Meu status",
      status: { online: "Online", away: "Ausente", busy: "Ocupado", offline: "Offline" },
      roles: { owner: "Proprietário", admin: "Admin", staff: "Colaborador" },
      rename: "Renomear",
      manage_members: "Gerenciar membros",
      delete_channel: "Excluir canal",
      select_channel: "Selecione um canal",
      loading_messages: "Carregando mensagens...",
      no_messages: "Nenhuma mensagem ainda.",
      be_first: "Seja o primeiro a escrever!",
      user: "Usuário",
      mention: "Mencionar",
      message_placeholder: "Digite sua mensagem... Use @ para mencionar",
      rename_channel: "Renomear Canal",
      new_name: "Novo nome",
      delete_channel_confirm: "Tem certeza que deseja excluir este canal? Todas as mensagens serão perdidas.",
      manage_channel_members: "Gerenciar Membros do Canal",
      manage_members_desc: "Selecione quem pode ver e enviar mensagens neste canal. Deixe vazio para todos terem acesso.",
      all_have_access: "Todos os membros da equipe terão acesso",
      members_selected: "{{count}} membro(s) selecionado(s)",
    },

    // Webhooks
    webhooks: {
      title: "Webhooks",
      subtitle: "Configure URLs para receber notificações de eventos do sistema",
      new_webhook: "Novo Webhook",
      create_webhook: "Criar Webhook",
      create_description: "Configure uma URL para receber notificações quando eventos ocorrerem",
      url: "URL do Webhook",
      events: "Eventos",
      configured: "Webhooks Configurados",
      manage_description: "Gerencie os webhooks que receberão notificações de eventos",
      no_webhooks: "Nenhum webhook configurado",
      fill_url_events: "Preencha a URL e selecione pelo menos um evento",
      created: "Webhook criado com sucesso",
      logs: "Logs do Webhook",
      logs_description: "Últimas 50 chamadas realizadas para este webhook",
      no_logs: "Nenhum log encontrado",
      no_response: "Sem resposta",
      delete_title: "Excluir Webhook",
      delete_confirm: "Tem certeza que deseja excluir este webhook? Esta ação não pode ser desfeita.",
    },

    // Packages
    packages: {
      title: "Pacotes & Sessões",
      subtitle: "Gerencie pacotes de serviços e créditos",
      sell_package: "Vender Pacote",
      new_package: "Novo Pacote",
      package_types: "Tipos de Pacotes",
      total_sold: "Total Vendidos",
      active_packages: "Pacotes Ativos",
      completed: "Concluídos",
      sessions: "sessões",
      remaining: "restantes",
      consume: "Consumir",
      renew: "Renovar",
      package_sales: "Vendas de Pacotes",
      search_placeholder: "Buscar por cliente ou pacote...",
      all: "Todos",
      active: "Ativos",
      cancelled: "Cancelados",
      no_packages_sold: "Nenhum pacote vendido encontrado",
      no_package_types: "Nenhum tipo de pacote cadastrado",
      new_package_type: "Novo Tipo de Pacote",
      name: "Nome",
      name_placeholder: "Ex: Pacote 10 Sessões",
      qty_sessions: "Qtd. Sessões",
      price: "Preço (R$)",
      linked_service: "Serviço Vinculado",
      optional: "Opcional",
      description: "Descrição",
      description_placeholder: "Descrição opcional...",
      create: "Criar Pacote",
      select_customer: "Selecionar Cliente",
      select_package: "Selecionar Pacote",
      expiration: "Validade",
      sell: "Vender Pacote",
      renew_package: "Renovar Pacote",
      additional_sessions: "Sessões Adicionais",
      new_expiration: "Nova Validade",
      confirm_renew: "Renovar Pacote",
    },

    // Quotes  
    quotes: {
      title: "Orçamentos",
      subtitle: "Crie e envie propostas comerciais para seus clientes",
      description: "Crie e envie propostas comerciais para seus clientes",
      new_quote: "Novo Orçamento",
      edit_quote: "Editar Orçamento",
      create_quote: "Criar Orçamento",
      save_changes: "Salvar Alterações",
      total: "Total",
      status: {
        draft: "Rascunho",
        sent: "Enviado",
        approved: "Aprovado",
        rejected: "Recusado",
      },
      draft: "Rascunho",
      sent: "Enviado",
      approved: "Aprovado",
      rejected: "Recusado",
      total_approved: "Total Aprovados",
      approved_value: "Valor Aprovado",
      customer: "Cliente",
      select_customer: "Selecione o cliente",
      search_customer: "Buscar cliente...",
      no_customer_found: "Nenhum cliente encontrado.",
      customer_placeholder: "Selecione o cliente",
      title_label: "Título",
      title_placeholder: "Ex: Proposta de serviços",
      description_optional: "Descrição (opcional)",
      refine_with_ai: "Refinar com IA",
      proposal_details: "Detalhes da proposta...",
      description_placeholder: "Detalhes da proposta...",
      items: "Itens",
      item: "Item",
      add: "Adicionar",
      item_name: "Nome do item",
      quantity_short: "Qtd",
      qty: "Qtd",
      price: "Preço",
      unit_price: "Preço Unit.",
      subtotal: "Subtotal",
      discount: "Desconto",
      search_placeholder: "Buscar por título ou cliente...",
      all_status: "Todos os status",
      no_quotes: "Nenhum orçamento",
      start_creating: "Comece criando seu primeiro orçamento",
      create_first: "Crie seu primeiro orçamento",
      send: "Enviar",
      copy_link: "Copiar Link",
      view: "Visualizar",
      print: "Imprimir",
      edit: "Editar",
      delete: "Excluir",
      share: "Compartilhar",
      convert_contract: "Converter em Contrato",
      generate_contract: "Gerar Contrato",
      create_project: "Criar Projeto",
      approve: "Aprovar",
      reject: "Rejeitar",
      delete_quote: "Excluir Orçamento",
      delete_confirmation: "Tem certeza que deseja excluir este orçamento? Esta ação não pode ser desfeita.",
      delete_confirm: "Tem certeza que deseja excluir este orçamento?",
      share_quote: "Compartilhar Orçamento",
      share_message: "Olá {{name}}, segue o link do seu orçamento:",
      quote_details: "Detalhes do Orçamento",
      created_at: "Criado em",
      responded_at: "Respondido em",
      generated_at: "Gerado em",
      add_title_or_description_first: "Adicione um título ou descrição primeiro",
      proposal_refined: "Proposta refinada com IA!",
      could_not_refine: "Não foi possível refinar a proposta",
      refine_error: "Erro ao refinar proposta",
      link_copied: "Link copiado!",
      sent_success: "Orçamento enviado!",
      approved_success: "Orçamento aprovado!",
      rejected_success: "Orçamento recusado!",
      converted_success: "Contrato criado!",
      project_created: "Projeto criado!",
      deleted: "Orçamento excluído!",
    },

    // NPS
    nps: {
      title: "Pesquisa de Satisfação (NPS)",
      subtitle: "Acompanhe a satisfação dos seus clientes",
      score: "Score NPS",
      excellent: "Excelente",
      very_good: "Muito bom",
      reasonable: "Razoável",
      needs_improvement: "Precisa melhorar",
      promoters: "Promotores",
      passives: "Neutros",
      detractors: "Detratores",
      scores_9_10: "Notas 9-10",
      scores_7_8: "Notas 7-8",
      scores_0_6: "Notas 0-6",
      responses_tab: "Respostas",
      config_tab: "Configurações",
      search_placeholder: "Buscar por cliente ou comentário...",
      category: "Categoria",
      all: "Todas",
      promoters_filter: "Promotores (9-10)",
      passives_filter: "Neutros (7-8)",
      detractors_filter: "Detratores (0-6)",
      pending_filter: "Não respondidos",
      loading: "Carregando...",
      no_surveys: "Nenhuma pesquisa encontrada",
      surveys_auto_sent: "As pesquisas serão enviadas automaticamente após os atendimentos",
      try_filters: "Tente ajustar os filtros",
      customer: "Cliente",
      responded_at: "Respondido em",
      sent_at: "Enviado em",
      comment: "Comentário",
      not_responded: "Não respondido",
      promoter: "Promotor",
      passive: "Neutro",
      detractor: "Detrator",
      auto_send: "Envio Automático",
      send_after_appointment: "Enviar após atendimento",
      send_after_description: "Envia pesquisa automaticamente após atendimentos concluídos",
      wait_time: "Tempo de espera (minutos)",
      wait_time_description: "Tempo após o atendimento para enviar a pesquisa",
      survey_questions: "Perguntas da Pesquisa",
      survey_questions_description: "Personalize as perguntas que seus clientes verão",
      main_question: "Pergunta Principal (Nota)",
      main_question_placeholder: "Em uma escala de 0 a 10, o quanto você recomendaria nosso serviço para um amigo ou colega?",
      main_question_description: "Pergunta que aparece junto com a escala de 0-10",
      comment_question: "Pergunta de Comentário",
      comment_question_description: "Pergunta opcional para coletar feedback em texto",
      comment_prompt_default: "O que motivou sua nota?",
      preview: "Preview da Pesquisa",
      your_comment: "Seu comentário (opcional)",
      save_config: "Salvar Configurações",
      saving: "Salvando...",
      config_saved: "Configurações salvas!",
    },

    // Satisfaction
    satisfaction: {
      title: "Pesquisas de Satisfação",
      subtitle: "Envie pesquisas e acompanhe a satisfação dos clientes",
      new_survey: "Nova Pesquisa",
      share_survey: "Compartilhar Pesquisa",
      send_survey: "Enviar Pesquisa de Satisfação",
      select_customer: "Selecione o cliente",
      create_survey: "Criar Pesquisa",
      survey_link: "Link da pesquisa:",
      copy_link: "Copiar Link",
      whatsapp: "WhatsApp",
      email: "Email",
      done: "Concluir",
      avg_score: "Média Geral",
      nps_score: "NPS Score",
      total_responses: "Total Respostas",
      churn_risk: "Risco de Churn",
      search_placeholder: "Buscar pesquisas...",
      sent_surveys: "Pesquisas Enviadas",
      loading: "Carregando...",
      no_surveys: "Nenhuma pesquisa encontrada",
      customer: "Cliente",
      score: "Nota",
      sentiment: "Sentimento",
      feedback: "Feedback",
      date: "Data",
      status: "Status",
      actions: "Ações",
      responded: "Respondida",
      pending: "Pendente",
      positive: "positivo",
      negative: "negativo",
      neutral: "neutro",
      link_copied: "Link copiado!",
      sent_whatsapp: "Pesquisa enviada via WhatsApp!",
      no_phone: "Cliente não possui telefone cadastrado",
      no_instance: "Nenhuma instância WhatsApp conectada",
      error_whatsapp: "Erro ao enviar WhatsApp",
    },

    // Referrals
    referrals: {
      title: "Programa de Indicações",
      subtitle: "Gerencie seu programa de indicação de clientes",
      total_referrals: "Total Indicações",
      converted: "Convertidas",
      pending: "Pendentes",
      conversion_rate: "Taxa Conversão",
      program_tab: "Programa",
      referrals_tab: "Indicações",
      status: "Status",
      active: "Ativo",
      inactive: "Inativo",
      paused: "Pausado",
      referred_reward: "Recompensa Indicado",
      referrer_reward: "Recompensa Indicador",
      discount: "desconto",
      no_program: "Nenhum programa ativo",
      no_program_description: "Configure um programa de indicações para seus clientes",
      received_referrals: "Indicações Recebidas",
      no_referrals: "Nenhuma indicação recebida ainda",
      referred: "Indicado",
      date: "Data",
      status_pending: "Pendente",
      status_converted: "Convertido",
      status_rewarded: "Recompensado",
      status_expired: "Expirado",
    },

    // Reactivation
    reactivation: {
      title: "Reativação de Clientes",
      subtitle: "Reconquiste clientes inativos",
      inactive_30: "+30 dias inativos",
      inactive_60: "+60 dias inativos",
      inactive_90: "+90 dias inativos",
      potential_revenue: "Receita potencial",
      search_placeholder: "Buscar cliente...",
      period: "Período",
      days_30: "+30 dias",
      days_60: "+60 dias",
      days_90: "+90 dias",
      days_180: "+180 dias",
      email: "E-mail",
      whatsapp: "WhatsApp",
      inactive_customers: "Clientes Inativos",
      select_all: "Selecionar todos",
      deselect_all: "Desmarcar todos",
      no_inactive: "Nenhum cliente inativo encontrado",
      great_news: "Ótimo! Seus clientes estão ativos.",
      days: "dias",
      last_visit: "Última:",
      never_visited: "Nunca visitou",
      visits: "visitas",
      select_at_least_one: "Selecione ao menos um cliente",
      no_whatsapp_instance: "Nenhuma instância WhatsApp conectada",
      messages_sent: "mensagens enviadas",
      failures: "falhas",
      emails_sent: "e-mails enviados",
    },

    // Automations
    automations: {
      title: "Automações",
      subtitle: "Configure ações automáticas baseadas no comportamento dos clientes",
      new_automation: "Nova Automação",
      create_automation: "Criar Nova Automação",
      automation_name: "Nome da automação *",
      automation_name_placeholder: "Ex: Reativação de clientes inativos",
      after_create_hint: "Após criar, você será direcionado para o editor visual onde poderá configurar gatilhos, condições e ações.",
      creating: "Criando...",
      create_and_configure: "Criar e Configurar",
      search_placeholder: "Buscar automação...",
      status_all: "Todos",
      status_active: "Ativas",
      status_inactive: "Inativas",
      loading: "Carregando...",
      no_automation_configured: "Nenhuma automação configurada",
      no_automation_found: "Nenhuma automação encontrada",
      create_automations_hint: "Crie automações para engajar seus clientes automaticamente",
      try_filters: "Tente ajustar os filtros",
      create_first: "Criar primeira automação",
      active: "Ativa",
      inactive: "Inativa",
      delete_title: "Excluir Automação",
      delete_description: "Tem certeza que deseja excluir esta automação? Esta ação não pode ser desfeita.",
      tags_count: "tag(s)",
    },

    // Tags Management
    tags_management: {
      title: "Tags / Etiquetas",
      subtitle: "Organize e categorize seus clientes com tags personalizadas",
      new_tag: "Nova Tag",
      edit_tag: "Editar Tag",
      tag_name: "Nome da Tag *",
      tag_name_placeholder: "Ex: VIP, Premium, Novo cliente...",
      color: "Cor",
      description_placeholder: "Descrição opcional...",
      update: "Atualizar",
      create: "Criar Tag",
      name_required: "Nome é obrigatório",
      tag_updated: "Tag atualizada!",
      tag_created: "Tag criada!",
      tag_deleted: "Tag excluída!",
      total_tags: "Total de Tags",
      customers_with_tags: "Clientes com Tags",
      tags_per_customer: "Tags por Cliente (média)",
      search_placeholder: "Buscar tags...",
      loading: "Carregando...",
      no_tag_created: "Nenhuma tag criada",
      no_tag_found: "Nenhuma tag encontrada",
      create_tags_hint: "Crie tags para organizar e categorizar seus clientes",
      try_search: "Tente ajustar a busca",
      create_first: "Criar primeira tag",
      customers: "cliente(s)",
      delete_title: "Excluir Tag",
      delete_description: "Tem certeza que deseja excluir esta tag? Ela será removida de todos os clientes.",
      colors: {
        blue: "Azul",
        green: "Verde",
        red: "Vermelho",
        yellow: "Amarelo",
        purple: "Roxo",
        pink: "Rosa",
        orange: "Laranja",
        teal: "Turquesa",
      },
    },

    // E-commerce
    ecommerce: {
      title: "E-commerce",
      subtitle: "Gerencie pedidos e pagamentos da sua loja",
      orders: "Pedidos",
      payments: "Pagamentos",
      products: "Produtos",
      settings: "Configurações",
      total_orders: "Total Pedidos",
      pending: "Pendentes",
      revenue: "Faturamento",
      avg_ticket: "Ticket Médio",
      search_placeholder: "Buscar por cliente, email ou ID...",
      filter_status: "Filtrar status",
      all_statuses: "Todos os status",
      no_orders: "Nenhum pedido encontrado",
      orders_appear: "Os pedidos aparecerão aqui quando clientes comprarem na sua loja.",
      order_details: "Detalhes do Pedido",
      tracking_code: "Código de Rastreio",
      tracking_placeholder: "Informe o código de rastreio",
      mark_shipped: "Marcar como Enviado",
      customer: "Cliente",
      shipping_address: "Endereço de Entrega",
      items: "Itens",
      qty: "Qtd",
      subtotal: "Subtotal",
      shipping: "Frete",
      discount: "Desconto",
      total: "Total",
      status_updated: "Status atualizado",
      
      // Products tab
      products_info_title: "Gerencie seus produtos",
      products_info_desc: "Os produtos cadastrados em Estoque aparecem aqui. Ative os que deseja vender online.",
      go_to_products: "Ir para Estoque & Produtos →",
      search_products: "Buscar produtos...",
      no_products_found: "Nenhum produto encontrado",
      no_products: "Nenhum produto cadastrado",
      try_different_search: "Tente uma busca diferente",
      add_products_first: "Cadastre produtos em Estoque para vendê-los aqui.",
      add_product: "Cadastrar Produto",
      low_stock: "Estoque baixo",
      active: "Ativo",
      inactive: "Inativo",
      stock: "Estoque",
      sell_online: "Vender online",
      product_enabled: "Produto habilitado",
      product_disabled: "Produto desabilitado",
      product_enabled_desc: "O produto agora está visível na loja",
      product_disabled_desc: "O produto foi ocultado da loja",
      update_error: "Erro ao atualizar produto",
      
      // Settings tab
      store_url: "Link da Loja",
      store_url_description: "Compartilhe este link para seus clientes acessarem sua loja",
      configure_slug: "Configure o slug da sua empresa nas configurações para ter um link personalizado.",
      url_copied: "Link da loja copiado para a área de transferência",
      shipping_settings: "Configurações de Entrega",
      default_shipping: "Taxa de entrega padrão",
      shipping_fee_note: "Deixe 0 para frete grátis",
      min_order_value: "Pedido mínimo",
      min_order_note: "Valor mínimo para finalizar pedido",
      free_shipping_above: "Frete grátis acima de",
      free_shipping_note: "Ofereça frete grátis para pedidos acima de um valor",
      notification_settings: "Notificações",
      whatsapp_notifications: "Notificar por WhatsApp",
      whatsapp_note: "Receba alertas de novos pedidos no WhatsApp",
      email_notifications: "Notificar por Email",
      email_note: "Receba alertas de novos pedidos por email",
      customer_notifications: "Notificar clientes",
      customer_note: "Envie atualizações de status para clientes",
      store_settings: "Configurações da Loja",
      store_enabled: "Loja ativa",
      store_enabled_note: "Desative para pausar as vendas temporariamente",
      show_prices: "Exibir preços",
      show_prices_note: "Mostrar preços dos produtos na loja",
      show_stock: "Exibir estoque",
      show_stock_note: "Mostrar quantidade disponível",
      
      // Stripe Connect
      configure_payments: "Configurar Recebimentos",
      stripe_not_configured: "Pagamentos não configurados",
      stripe_description: "Configure sua conta para receber pagamentos diretamente. O dinheiro das vendas vai direto para sua conta bancária.",
      how_it_works: "Como funciona",
      step_1_title: "Conecte sua conta",
      step_1_desc: "Clique no botão abaixo para criar sua conta no Stripe. É gratuito.",
      step_2_title: "Complete o cadastro",
      step_2_desc: "Preencha seus dados bancários e documentos para verificação.",
      step_3_title: "Comece a vender!",
      step_3_desc: "Após aprovação, você já pode receber por cartão, PIX e mais.",
      benefit_security: "Seguro",
      benefit_security_desc: "Proteção contra fraudes",
      benefit_transfers: "Automático",
      benefit_transfers_desc: "Transferências automáticas",
      benefit_methods: "Múltiplos meios",
      benefit_methods_desc: "Cartão, PIX, boleto",
      connect_stripe: "Conectar com Stripe",
      stripe_note: "O Stripe cobra uma taxa de ~3.5% + R$0.40 por transação. Sem mensalidades.",
      stripe_account: "Conta Stripe",
      account_status: "Status da Conta",
      status_active: "Ativo",
      status_pending: "Pendente",
      receive_payments: "Receber Pagamentos",
      receive_payouts: "Receber Saques",
      enabled: "Habilitado",
      incomplete_setup: "Configuração incompleta",
      incomplete_description: "Sua conta precisa de informações adicionais para começar a receber pagamentos.",
      complete_registration: "Completar Cadastro",
      ready_to_sell: "Pronto para vender!",
      ready_description: "Sua conta está ativa. Os pagamentos serão transferidos automaticamente.",
      manage_stripe: "Gerenciar no Stripe",
      
      status: {
        pending: "Pendente",
        paid: "Pago",
        processing: "Processando",
        shipped: "Enviado",
        delivered: "Entregue",
        cancelled: "Cancelado",
        refunded: "Reembolsado",
      },
      stripe_connect: {
        title: "Stripe Connect",
        description: "Conecte sua conta Stripe para receber pagamentos diretamente na sua conta bancária.",
        setup: "Configurar Stripe Connect",
        setting_up: "Configurando...",
        status_pending: "Pendente",
        status_active: "Ativo",
        payments_enabled: "Pagamentos habilitados",
        payouts_enabled: "Saques habilitados",
        go_to_dashboard: "Ir para Dashboard Stripe",
      },
    },
    
    // Security & Privacy
    security: {
      title: "Segurança e Privacidade",
      description: "Proteção de dados e configurações de segurança",
      access_token: "Token de Acesso",
      access_token_description: "Token único para acesso seguro ao pedido",
      token_generated: "Token gerado automaticamente",
      token_secure: "Acesso seguro via token",
      track_order: "Acompanhar Pedido",
      order_link: "Link do Pedido",
      copy_link: "Copiar Link",
      link_copied: "Link copiado!",
      send_to_customer: "Enviar para Cliente",
      data_protection: "Proteção de Dados",
      sensitive_data: "Dados Sensíveis",
      restricted_access: "Acesso Restrito",
      only_owners_admins: "Apenas proprietários e administradores",
      staff_can_view_own: "Funcionário pode ver próprios dados",
      salary_hidden: "Salário oculto para outros",
      bank_data_protected: "Dados bancários protegidos",
      access_levels: "Níveis de Acesso",
      owner: "Proprietário",
      admin: "Administrador",
      manager: "Gerente",
      staff_role: "Funcionário",
      full_access: "Acesso completo",
      limited_access: "Acesso limitado",
      view_only: "Apenas visualização",
      lgpd_compliance: "Conformidade LGPD",
      hipaa_compliance: "Conformidade HIPAA",
      data_encrypted: "Dados criptografados",
      audit_logs: "Logs de auditoria",
      two_factor_auth: "Autenticação em dois fatores",
      session_timeout: "Tempo limite de sessão",
    },
    
    // Reviews Module
    reviews: {
      title: "Avaliações",
      subtitle: "Gerencie avaliações e reputação do seu negócio",
      average_rating: "Nota Média",
      total: "Total de Avaliações",
      pending: "Pendentes",
      public: "Públicas",
      distribution: "Distribuição de Notas",
      all_reviews: "Todas as Avaliações",
      search: "Buscar avaliações...",
      all: "Todas",
      approved: "Aprovadas",
      approve: "Aprovar",
      reject: "Rejeitar",
      respond: "Responder",
      hide: "Ocultar",
      show: "Tornar Pública",
      no_reviews: "Nenhuma avaliação encontrada",
      no_comment: "Sem comentário",
      your_response: "Sua resposta:",
      write_response: "Escreva sua resposta...",
      send_response: "Enviar Resposta",
      // Display settings
      settings: "Configurações",
      display_settings: "Configurações de Exibição",
      display_settings_desc: "Escolha onde suas avaliações aprovadas serão exibidas",
      locations: "Locais",
      widget: "Widget",
      minisite: "Mini-site",
      minisite_desc: "Exibir avaliações na página principal do mini-site",
      catalog: "Catálogo",
      catalog_desc: "Exibir avaliações no catálogo de produtos",
      store: "Loja",
      store_desc: "Exibir avaliações na loja online",
      max_displayed: "Máximo de avaliações exibidas",
      show_stats: "Mostrar estatísticas",
      show_stats_desc: "Exibir nota média e total de avaliações",
      enable_widget: "Ativar Widget",
      enable_widget_desc: "Permite incorporar avaliações em sites externos",
      js_widget: "Widget JavaScript",
      iframe_widget: "Widget iFrame",
      copy: "Copiar",
      preview: "Prévia",
      preview_hint: "As avaliações aparecerão aqui quando você incorporar o widget em seu site externo.",
      code_copied: "Código {{type}} copiado!",
      // Public display
      public_title: "O que nossos clientes dizem",
      reviews_count: "avaliações",
      anonymous: "Cliente",
      business_response: "Resposta do estabelecimento:",
    },
  },
};
